
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jWuk1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e84af46a5b39465b$var$_react = $e84af46a5b39465b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e84af46a5b39465b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e84af46a5b39465b$var$CrossIcon = (props)=>/*#__PURE__*/ $e84af46a5b39465b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$e84af46a5b39465b$var$CrossIcon.displayName = 'CrossIcon';
var $e84af46a5b39465b$var$_default = $e84af46a5b39465b$var$CrossIcon;
module.exports.default = $e84af46a5b39465b$var$_default;

});
parcelRegister("2ziLQ", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $4cfea663421c0a4d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $4cfea663421c0a4d$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bVhyO = parcelRequire("bVhyO");

var $5Y0DT = parcelRequire("5Y0DT");
function $4cfea663421c0a4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4cfea663421c0a4d$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ...(0, $5Y0DT.commonSVGStyles),
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    }
});
/**
 * For windows high contrast mode
 */ const $4cfea663421c0a4d$var$baseHcmStyles = {
    name: "tdbe8",
    styles: "@media screen and (forced-colors: active){> svg{filter:grayscale(1);--icon-primary-color:CanvasText;--icon-secondary-color:Canvas;}}"
};
const $4cfea663421c0a4d$var$primaryEqualsSecondaryHcmStyles = {
    name: "1pgb0eo",
    styles: "@media screen and (forced-colors: active){> svg{--icon-primary-color:Canvas;}}"
};
const $4cfea663421c0a4d$var$secondaryTransparentHcmStyles = {
    name: "s2qd3p",
    styles: "@media screen and (forced-colors: active){> svg{--icon-secondary-color:transparent;}}"
};
const $4cfea663421c0a4d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $byn9U.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const dimensions = (0, $5Y0DT.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $bVhyO.getBackground)()
        },
        ...glyphProps,
        css: [
            $4cfea663421c0a4d$var$iconStyles,
            $4cfea663421c0a4d$var$baseHcmStyles,
            primaryColor === secondaryColor && $4cfea663421c0a4d$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $4cfea663421c0a4d$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    });
});
var $4cfea663421c0a4d$export$2e2bcd8739ae039 = $4cfea663421c0a4d$export$f04a61298a47a40f;

});
parcelRegister("bVhyO", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $8f72acb843e05dd4$export$18cb9425622d4e06);
const $8f72acb843e05dd4$export$18cb9425622d4e06 = ()=>"var(--ds-surface, #FFFFFF)";

});

parcelRegister("5Y0DT", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $86eab883ff757af2$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $86eab883ff757af2$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $86eab883ff757af2$export$3eb7d6130acfda37);

var $cAX3Z = parcelRequire("cAX3Z");

var $byn9U = parcelRequire("byn9U");
const $86eab883ff757af2$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $86eab883ff757af2$var$smallStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $cAX3Z.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $86eab883ff757af2$var$mediumStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $cAX3Z.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $86eab883ff757af2$var$largeStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $cAX3Z.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $86eab883ff757af2$var$xlargeStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $cAX3Z.dimensions).xlarge);
const $86eab883ff757af2$export$ef0ad74202575b64 = {
    small: $86eab883ff757af2$var$smallStyles,
    medium: $86eab883ff757af2$var$mediumStyles,
    large: $86eab883ff757af2$var$largeStyles,
    xlarge: $86eab883ff757af2$var$xlargeStyles
};
const $86eab883ff757af2$export$3eb7d6130acfda37 = ({ width: width, height: height, size: size })=>{
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $cAX3Z.dimensions)[size];
    return undefined;
};

});
parcelRegister("cAX3Z", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $e48f0ff69fb3355e$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "dimensions", () => $e48f0ff69fb3355e$export$62ad7b0c781000e9);
const $e48f0ff69fb3355e$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $e48f0ff69fb3355e$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $e48f0ff69fb3355e$export$62ad7b0c781000e9 = {
    small: {
        width: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.small,
        height: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.medium,
        height: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.large,
        height: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.xlarge,
        height: $e48f0ff69fb3355e$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("ajCg0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78295ad300ee447c$var$_react = $78295ad300ee447c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $78295ad300ee447c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $78295ad300ee447c$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $78295ad300ee447c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.744 8.744a1.053 1.053 0 000 1.49l4.547 4.557a1 1 0 001.416 0l4.55-4.558a1.051 1.051 0 10-1.488-1.488l-3.77 3.776-3.768-3.776a1.051 1.051 0 00-1.487 0z" fill="currentColor"/></svg>`
    }, props));
$78295ad300ee447c$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $78295ad300ee447c$var$_default = $78295ad300ee447c$var$HipchatChevronDownIcon;
module.exports.default = $78295ad300ee447c$var$_default;

});

parcelRegister("h0grN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c60f31d72c65b6c7$var$_react = $c60f31d72c65b6c7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c60f31d72c65b6c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c60f31d72c65b6c7$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $c60f31d72c65b6c7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.294 8.708l-.001.001-4.549 4.559a1.051 1.051 0 101.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 001.486.001h.001a1.054 1.054 0 00.001-1.489l-4.548-4.558a1 1 0 00-1.415-.001z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c60f31d72c65b6c7$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $c60f31d72c65b6c7$var$_default = $c60f31d72c65b6c7$var$HipchatChevronUpIcon;
module.exports.default = $c60f31d72c65b6c7$var$_default;

});

parcelRegister("78oCb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7u4fN")).default);
$parcel$export(module.exports, "LoadingButton", () => (parcelRequire("7opLA")).default);
$parcel$export(module.exports, "CustomThemeButton", () => (parcelRequire("bbaTG")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("Sibrq")).default);
$parcel$export(module.exports, "ButtonGroup", () => (parcelRequire("bLFgh")).default);
// Ideally this file is not used directly. But rather, you go through the entry points

var $7u4fN = parcelRequire("7u4fN");

var $7opLA = parcelRequire("7opLA");

var $bbaTG = parcelRequire("bbaTG");
var $Sibrq = parcelRequire("Sibrq");

var $bLFgh = parcelRequire("bLFgh");

});
parcelRegister("7u4fN", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c14c413236f8fa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $6rmE5 = parcelRequire("6rmE5");

var $lHbz7 = parcelRequire("lHbz7");

var $dvp51 = parcelRequire("dvp51");

var $jRP2t = parcelRequire("jRP2t");
const $78c14c413236f8fa$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * CAUTION: Legacy buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new`.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $78c14c413236f8fa$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), onMouseUp: providedOnMouseUp = (0, $5Q9wj.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $6rmE5.useGlobalTheme)();
    const isOnlySingleIcon = (0, $jRP2t.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eUqFw.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($78c14c413236f8fa$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($78c14c413236f8fa$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eUqFw.useMemo)(()=>(0, $dvp51.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lHbz7.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$78c14c413236f8fa$var$Button.displayName = 'Button';
var $78c14c413236f8fa$export$2e2bcd8739ae039 = $78c14c413236f8fa$var$Button;

});
parcelRegister("5Q9wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $536fe9a741355082$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $536fe9a741355082$export$2e2bcd8739ae039() {}

});

parcelRegister("6rmE5", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $2257f6ff72fc7de1$export$7692396083754928);
$parcel$export(module.exports, "default", () => $2257f6ff72fc7de1$export$2e2bcd8739ae039);

var $jQBE2 = parcelRequire("jQBE2");
// Create default global light theme
const { Provider: $2257f6ff72fc7de1$var$Provider, Consumer: $2257f6ff72fc7de1$var$Consumer, useTheme: $2257f6ff72fc7de1$export$7692396083754928 } = (0, $jQBE2.createTheme)(()=>({
        mode: 'light'
    }));
var $2257f6ff72fc7de1$export$2e2bcd8739ae039 = {
    Provider: $2257f6ff72fc7de1$var$Provider,
    Consumer: $2257f6ff72fc7de1$var$Consumer
};

});
parcelRegister("jQBE2", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $9f24141e4cabdc10$export$25d302a5b900a763);

var $eUqFw = parcelRequire("eUqFw");
function $9f24141e4cabdc10$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $eUqFw.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(tokens));
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $eUqFw.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $eUqFw.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("lHbz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b1aa3c83b33477$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $hhlqA = parcelRequire("hhlqA");

var $51sCz = parcelRequire("51sCz");

var $jsCXU = parcelRequire("jsCXU");

var $PdmhA = parcelRequire("PdmhA");

var $dESWZ = parcelRequire("dESWZ");

var $dvp51 = parcelRequire("dvp51");

var $aUI58 = parcelRequire("aUI58");
function $83b1aa3c83b33477$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $83b1aa3c83b33477$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $83b1aa3c83b33477$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $83b1aa3c83b33477$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $83b1aa3c83b33477$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $aUI58.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $83b1aa3c83b33477$var$getChildren = (children, childrenStyles)=>{
    if ((0, $aUI58.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $83b1aa3c83b33477$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $5Q9wj.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eUqFw.useRef)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $hhlqA.default)(ourRef, autoFocus);
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $dvp51.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $PdmhA.N500})` : `var(--ds-icon-warning-inverse, ${0, $PdmhA.N500})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), null, /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $83b1aa3c83b33477$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $dESWZ.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dvp51.getIconStyle)({
                spacing: spacing
            }),
            $83b1aa3c83b33477$var$getSpacingFix(children, $83b1aa3c83b33477$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $83b1aa3c83b33477$var$getChildren(children, [
        fadeStyles,
        (0, $dvp51.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dvp51.getIconStyle)({
                spacing: spacing
            }),
            $83b1aa3c83b33477$var$getSpacingFix(children, $83b1aa3c83b33477$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $dvp51.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("lUFyV", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $625a63b3b286ef0c$export$a4687b0234b40e28);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $gNgZO = parcelRequire("gNgZO");
function $625a63b3b286ef0c$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gNgZO.useTrackedRef)(analyticsData);
    const fnRef = (0, $gNgZO.useTrackedRef)(fn);
    const handler = (0, $eUqFw.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bFzGY", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $6547be6dc6d9ee9b$export$5bf35293e545f20c);

var $fzXll = parcelRequire("fzXll");

var $cPQ3Q = parcelRequire("cPQ3Q");

var $369Kv = parcelRequire("369Kv");
function $6547be6dc6d9ee9b$export$5bf35293e545f20c() {
    const analyticsContext = (0, $369Kv.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $fzXll.useCallbackOne)((payload)=>{
        return new (0, $cPQ3Q.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("cPQ3Q", function(module, exports) {

$parcel$export(module.exports, "isUIAnalyticsEvent", () => $c8b1e97332b7ce92$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $c8b1e97332b7ce92$export$2e2bcd8739ae039);

var $64G28 = parcelRequire("64G28");
const $c8b1e97332b7ce92$export$35f8383928ba8d7 = (obj)=>obj instanceof $c8b1e97332b7ce92$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $c8b1e97332b7ce92$export$2e2bcd8739ae039 extends (0, $64G28.default) {
    constructor(props){
        super(props);
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $c8b1e97332b7ce92$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("64G28", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac793a0e5a2bd25$export$2e2bcd8739ae039);
const $0ac793a0e5a2bd25$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $0ac793a0e5a2bd25$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $0ac793a0e5a2bd25$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $0ac793a0e5a2bd25$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("369Kv", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $17307d288b224d8c$export$d1f587f82ad51c4);

var $eUqFw = parcelRequire("eUqFw");

var $kNx8v = parcelRequire("kNx8v");
const $17307d288b224d8c$export$d1f587f82ad51c4 = ()=>{
    return (0, $eUqFw.useContext)((0, $kNx8v.default));
};

});
parcelRegister("kNx8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f242166df34948f8$export$2e2bcd8739ae039);

var $2Arnw = parcelRequire("2Arnw");
var $f242166df34948f8$export$2e2bcd8739ae039 = (0, $2Arnw.default);

});
parcelRegister("2Arnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e242e5d1a467c15$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $1e242e5d1a467c15$var$AnalyticsNextContext = (0, $eUqFw.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $1e242e5d1a467c15$export$2e2bcd8739ae039 = $1e242e5d1a467c15$var$AnalyticsNextContext;

});




parcelRegister("gNgZO", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $962711f1169d504d$export$1d27a74659855e44);

var $eUqFw = parcelRequire("eUqFw");
const $962711f1169d504d$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("hhlqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $78f2a10ac5ca107d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $78f2a10ac5ca107d$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("51sCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5bac5d1ec50a29$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $7c5bac5d1ec50a29$var$BORDER_WIDTH = 2;
const $7c5bac5d1ec50a29$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $byn9U.css)({
    outline: `${$7c5bac5d1ec50a29$var$BORDER_WIDTH}px solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $7c5bac5d1ec50a29$var$BORDER_WIDTH
});
const $7c5bac5d1ec50a29$var$baseInsetStyles = /*#__PURE__*/ (0, $byn9U.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$7c5bac5d1ec50a29$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
const $7c5bac5d1ec50a29$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    '&:focus-visible': $7c5bac5d1ec50a29$var$baseFocusOutsideStyles,
    '@supports not selector(*:focus-visible)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '&:focus': $7c5bac5d1ec50a29$var$baseFocusOutsideStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $7c5bac5d1ec50a29$var$insetFocusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    '&:focus-visible': $7c5bac5d1ec50a29$var$baseInsetStyles,
    '@supports not selector(*:focus-visible)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '&:focus': $7c5bac5d1ec50a29$var$baseInsetStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $7c5bac5d1ec50a29$var$FocusRing = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $7c5bac5d1ec50a29$var$baseInsetStyles : $7c5bac5d1ec50a29$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $7c5bac5d1ec50a29$var$insetFocusRingStyles : $7c5bac5d1ec50a29$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css, cx: cx })=>(0, $eUqFw.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$7c5bac5d1ec50a29$var$FocusRing.displayName = 'FocusRing';
var $7c5bac5d1ec50a29$export$2e2bcd8739ae039 = $7c5bac5d1ec50a29$var$FocusRing;

});

parcelRegister("PdmhA", function(module, exports) {

$parcel$export(module.exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export(module.exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export(module.exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export(module.exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export(module.exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export(module.exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export(module.exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export(module.exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export(module.exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export(module.exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export(module.exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export(module.exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export(module.exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export(module.exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export(module.exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export(module.exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export(module.exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export(module.exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export(module.exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export(module.exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export(module.exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export(module.exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export(module.exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export(module.exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export(module.exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export(module.exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export(module.exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export(module.exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export(module.exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export(module.exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export(module.exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export(module.exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export(module.exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export(module.exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export(module.exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export(module.exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export(module.exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export(module.exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export(module.exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export(module.exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export(module.exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export(module.exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export(module.exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export(module.exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export(module.exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export(module.exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export(module.exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export(module.exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export(module.exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export(module.exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
$parcel$export(module.exports, "background", () => $73a5c9d720aa66e1$export$8ce1fd94bee2f412);
$parcel$export(module.exports, "backgroundActive", () => $73a5c9d720aa66e1$export$b861914ea877b580);
$parcel$export(module.exports, "backgroundHover", () => $73a5c9d720aa66e1$export$3f1b020df94387af);
$parcel$export(module.exports, "backgroundOnLayer", () => $73a5c9d720aa66e1$export$c0183dbab98ca63e);
$parcel$export(module.exports, "text", () => $73a5c9d720aa66e1$export$6f093cfa640b7166);
$parcel$export(module.exports, "textHover", () => $73a5c9d720aa66e1$export$42f8e9c698766e7a);
$parcel$export(module.exports, "textActive", () => $73a5c9d720aa66e1$export$c2d157ca1c34b6e3);
$parcel$export(module.exports, "subtleText", () => $73a5c9d720aa66e1$export$1905ba28d7cf066f);
$parcel$export(module.exports, "placeholderText", () => $73a5c9d720aa66e1$export$bd9002130d306d39);
$parcel$export(module.exports, "heading", () => $73a5c9d720aa66e1$export$46e4a324ac90507f);
$parcel$export(module.exports, "subtleHeading", () => $73a5c9d720aa66e1$export$79f3f2b82beb0d36);
$parcel$export(module.exports, "codeBlock", () => $73a5c9d720aa66e1$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "link", () => $73a5c9d720aa66e1$export$9c30223ca0a664fb);
$parcel$export(module.exports, "linkHover", () => $73a5c9d720aa66e1$export$7ed258b0728b004b);
$parcel$export(module.exports, "linkActive", () => $73a5c9d720aa66e1$export$dfa920d8decc8a59);
$parcel$export(module.exports, "linkOutline", () => $73a5c9d720aa66e1$export$6069e6ad5c78f632);
$parcel$export(module.exports, "primary", () => $73a5c9d720aa66e1$export$9ad721cf3b3debe0);
$parcel$export(module.exports, "blue", () => $73a5c9d720aa66e1$export$2aa0182783e7e9de);
$parcel$export(module.exports, "teal", () => $73a5c9d720aa66e1$export$8bf7dff220b82b4a);
$parcel$export(module.exports, "purple", () => $73a5c9d720aa66e1$export$e13cce2a2d16a9d4);
$parcel$export(module.exports, "red", () => $73a5c9d720aa66e1$export$a90204d1394caf30);
$parcel$export(module.exports, "yellow", () => $73a5c9d720aa66e1$export$594c5a8758200c32);
$parcel$export(module.exports, "green", () => $73a5c9d720aa66e1$export$955a2ebd2fb142ae);
$parcel$export(module.exports, "skeleton", () => $73a5c9d720aa66e1$export$2a0674ff2eb10214);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $3bNek = parcelRequire("3bNek");
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $73a5c9d720aa66e1$export$8ce1fd94bee2f412 = (0, $3bNek.default)({
    light: `var(--ds-surface, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    dark: `var(--ds-surface, ${$73a5c9d720aa66e1$export$633847cf062b69e0})`
});
const $73a5c9d720aa66e1$export$b861914ea877b580 = (0, $3bNek.default)({
    light: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    dark: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
});
const $73a5c9d720aa66e1$export$3f1b020df94387af = (0, $3bNek.default)({
    light: `var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    dark: `var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$d281fbfe3cff2df6})`
});
const $73a5c9d720aa66e1$export$c0183dbab98ca63e = (0, $3bNek.default)({
    light: `var(--ds-surface-overlay, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    dark: `var(--ds-surface-overlay, ${$73a5c9d720aa66e1$export$8e8133c1ba5845b5})`
});
const $73a5c9d720aa66e1$export$6f093cfa640b7166 = (0, $3bNek.default)({
    light: `var(--ds-text, ${$73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
    dark: `var(--ds-text, ${$73a5c9d720aa66e1$export$5368d76ae4fbbda7})`
});
const $73a5c9d720aa66e1$export$42f8e9c698766e7a = (0, $3bNek.default)({
    light: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$73a5c9d720aa66e1$export$5368d76ae4fbbda7})`
});
const $73a5c9d720aa66e1$export$c2d157ca1c34b6e3 = (0, $3bNek.default)({
    light: `var(--ds-text-selected, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-text-selected, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`
});
const $73a5c9d720aa66e1$export$1905ba28d7cf066f = (0, $3bNek.default)({
    light: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$97e81faa16a182c7})`
});
const $73a5c9d720aa66e1$export$bd9002130d306d39 = (0, $3bNek.default)({
    light: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$bfe21c59123ecf33})`
});
const $73a5c9d720aa66e1$export$46e4a324ac90507f = (0, $3bNek.default)({
    light: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$73a5c9d720aa66e1$export$5368d76ae4fbbda7})`
});
const $73a5c9d720aa66e1$export$79f3f2b82beb0d36 = (0, $3bNek.default)({
    light: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$97e81faa16a182c7})`
});
const $73a5c9d720aa66e1$export$7bb0d5c671655cc4 = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$9fdfb749e33cdf97,
    dark: $73a5c9d720aa66e1$export$8e8133c1ba5845b5
});
const $73a5c9d720aa66e1$export$9c30223ca0a664fb = (0, $3bNek.default)({
    light: `var(--ds-link, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-link, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`
});
const $73a5c9d720aa66e1$export$7ed258b0728b004b = (0, $3bNek.default)({
    light: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    dark: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$215b7063051591f1})`
});
const $73a5c9d720aa66e1$export$dfa920d8decc8a59 = (0, $3bNek.default)({
    light: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    dark: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`
});
const $73a5c9d720aa66e1$export$6069e6ad5c78f632 = (0, $3bNek.default)({
    light: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$215b7063051591f1})`,
    dark: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$215b7063051591f1})`
});
const $73a5c9d720aa66e1$export$9ad721cf3b3debe0 = (0, $3bNek.default)({
    light: `var(--ds-background-brand-bold, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-background-brand-bold, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`
});
const $73a5c9d720aa66e1$export$2aa0182783e7e9de = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$b3de0ae08da2ce64,
    dark: $73a5c9d720aa66e1$export$ecfc1dff386a3e7a
});
const $73a5c9d720aa66e1$export$8bf7dff220b82b4a = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$9dc1ef0f3f48059b,
    dark: $73a5c9d720aa66e1$export$69cb3ca10c1e330e
});
const $73a5c9d720aa66e1$export$e13cce2a2d16a9d4 = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$b48405b95304b5a1,
    dark: $73a5c9d720aa66e1$export$6011520a64d9a187
});
const $73a5c9d720aa66e1$export$a90204d1394caf30 = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$4a7404f376229999,
    dark: $73a5c9d720aa66e1$export$4a7404f376229999
});
const $73a5c9d720aa66e1$export$594c5a8758200c32 = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$c6930421db9fa514,
    dark: $73a5c9d720aa66e1$export$c6930421db9fa514
});
const $73a5c9d720aa66e1$export$955a2ebd2fb142ae = (0, $3bNek.default)({
    light: $73a5c9d720aa66e1$export$940e1f69e873f202,
    dark: $73a5c9d720aa66e1$export$940e1f69e873f202
});
const $73a5c9d720aa66e1$export$2a0674ff2eb10214 = ()=>`var(--ds-skeleton, ${$73a5c9d720aa66e1$export$8d43898f60b96a82})`;

});
parcelRegister("3bNek", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9fa30c58a43d0ed$export$2e2bcd8739ae039);
/* eslint-disable prefer-rest-params */ 
var $e79Bj = parcelRequire("e79Bj");
// Unpack custom variants, and get correct value for the current theme
function $d9fa30c58a43d0ed$var$themedVariants(variantProp, variants) {
    return (props)=>{
        const theme = (0, $e79Bj.default)(props);
        if (props && props[variantProp] && variants) {
            const modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                const value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $d9fa30c58a43d0ed$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $d9fa30c58a43d0ed$var$themedVariants(modesOrVariant, variantModes);
    const modes = modesOrVariant;
    return (props)=>{
        // Get theme from the user's props
        const theme = (0, $e79Bj.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            const value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("e79Bj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2a641f0710abea$export$2e2bcd8739ae039);

var $lcnyw = parcelRequire("lcnyw");
function $2c2a641f0710abea$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $lcnyw.CHANNEL) in props.theme) return props.theme[0, $lcnyw.CHANNEL];
        else if ('mode' in props.theme && (0, $lcnyw.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $lcnyw.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("lcnyw", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", () => $5a4a1f9909b989fe$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $5a4a1f9909b989fe$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $5a4a1f9909b989fe$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "borderRadius", () => $5a4a1f9909b989fe$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $5a4a1f9909b989fe$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "fontSize", () => $5a4a1f9909b989fe$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontSizeSmall", () => $5a4a1f9909b989fe$export$6746fe0d9c9fab54);
$parcel$export(module.exports, "fontFamily", () => $5a4a1f9909b989fe$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $5a4a1f9909b989fe$export$356129969ee49c55);
$parcel$export(module.exports, "noFocusRing", () => $5a4a1f9909b989fe$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $5a4a1f9909b989fe$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $5a4a1f9909b989fe$export$e497e856b4f89fcd);

var $1Ivg5 = parcelRequire("1Ivg5");

var $PdmhA = parcelRequire("PdmhA");
const $5a4a1f9909b989fe$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $5a4a1f9909b989fe$export$c93026a968943f95 = 'light';
const $5a4a1f9909b989fe$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $5a4a1f9909b989fe$export$7a57f79000377ca2 = ()=>3;
const $5a4a1f9909b989fe$export$6d8204c2cb2e06b8 = ()=>8;
const $5a4a1f9909b989fe$export$85e3c3ca0c6fb93 = ()=>14;
const $5a4a1f9909b989fe$export$6746fe0d9c9fab54 = ()=>11;
const $5a4a1f9909b989fe$export$a5975749f0374264 = ()=>`-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const $5a4a1f9909b989fe$export$356129969ee49c55 = ()=>`'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace`;
const $5a4a1f9909b989fe$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $PdmhA.B200})`, outlineWidth = $5a4a1f9909b989fe$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $1Ivg5.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $5a4a1f9909b989fe$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $5a4a1f9909b989fe$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $5a4a1f9909b989fe$export$a1b3edb637fb4f35 = ()=>{
    (0, $1Ivg5.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $5a4a1f9909b989fe$export$ba1d834b86d72a09 = $5a4a1f9909b989fe$export$a1b3edb637fb4f35;
const $5a4a1f9909b989fe$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.skeleton)()})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.skeleton)()})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $PdmhA.N30A})`
            }
        }
    });

});
parcelRegister("1Ivg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $251999cc9087d2c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "propDeprecationWarning", () => $251999cc9087d2c3$export$eb1decd851a5ae56);

var $9DLBc = parcelRequire("9DLBc");

var $2fFJv = parcelRequire("2fFJv");
function $251999cc9087d2c3$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $9DLBc.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $251999cc9087d2c3$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $2fFJv;
}

});
parcelRegister("9DLBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e63a1d75344801dd$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $e63a1d75344801dd$var$printed = {};
function $e63a1d75344801dd$export$2e2bcd8739ae039(message) {
    if ($e63a1d75344801dd$var$printed[message]) return;
    $e63a1d75344801dd$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("dESWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $df62cff16316c757$export$2e2bcd8739ae039);
function $df62cff16316c757$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $df62cff16316c757$var$tabKeyCode = 9;
function $df62cff16316c757$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $df62cff16316c757$var$tabKeyCode) return;
    $df62cff16316c757$var$abort(event);
}
const $df62cff16316c757$var$block = {
    onMouseDownCapture: $df62cff16316c757$var$abort,
    onMouseUpCapture: $df62cff16316c757$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $df62cff16316c757$var$onKey,
    onKeyUpCapture: $df62cff16316c757$var$onKey,
    onTouchStartCapture: $df62cff16316c757$var$abort,
    onTouchEndCapture: $df62cff16316c757$var$abort,
    onPointerDownCapture: $df62cff16316c757$var$abort,
    onPointerUpCapture: $df62cff16316c757$var$abort,
    onClickCapture: $df62cff16316c757$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $df62cff16316c757$var$abort
};
const $df62cff16316c757$var$doNotBlock = {};
function $df62cff16316c757$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $df62cff16316c757$var$doNotBlock : $df62cff16316c757$var$block;
}

});

parcelRegister("dvp51", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $aa95bf9e76b6b9cc$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $aa95bf9e76b6b9cc$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $aa95bf9e76b6b9cc$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $aa95bf9e76b6b9cc$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $aa95bf9e76b6b9cc$export$1a9fe1b84c876bb5);

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $kl686 = parcelRequire("kl686");
const $aa95bf9e76b6b9cc$var$gridSize = (0, $lcnyw.gridSize)();
const $aa95bf9e76b6b9cc$var$fontSize = (0, $lcnyw.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $aa95bf9e76b6b9cc$var$heights = {
    default: `${$aa95bf9e76b6b9cc$var$gridSize * 4 / $aa95bf9e76b6b9cc$var$fontSize}em`,
    // 32px
    compact: `${$aa95bf9e76b6b9cc$var$gridSize * 3 / $aa95bf9e76b6b9cc$var$fontSize}em`,
    none: 'auto'
};
const $aa95bf9e76b6b9cc$var$lineHeights = {
    default: $aa95bf9e76b6b9cc$var$heights.default,
    compact: $aa95bf9e76b6b9cc$var$heights.compact,
    none: 'inherit'
};
const $aa95bf9e76b6b9cc$var$padding = {
    // 10px gutter
    default: `0 ${$aa95bf9e76b6b9cc$var$gridSize + $aa95bf9e76b6b9cc$var$gridSize / 4}px`,
    compact: `0 ${$aa95bf9e76b6b9cc$var$gridSize + $aa95bf9e76b6b9cc$var$gridSize / 4}px`,
    none: '0'
};
const $aa95bf9e76b6b9cc$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$aa95bf9e76b6b9cc$var$gridSize / 4}px`,
    default: `0 ${$aa95bf9e76b6b9cc$var$gridSize / 4}px`,
    none: '0'
};
const $aa95bf9e76b6b9cc$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $aa95bf9e76b6b9cc$var$innerMargin = {
    content: `0 ${$aa95bf9e76b6b9cc$var$gridSize / 4}px`,
    icon: `0 ${$aa95bf9e76b6b9cc$var$gridSize / 4}px`
};
function $aa95bf9e76b6b9cc$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $aa95bf9e76b6b9cc$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $aa95bf9e76b6b9cc$var$getColor({
            group: (0, $kl686.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$aa95bf9e76b6b9cc$var$getColor({
            group: (0, $kl686.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $aa95bf9e76b6b9cc$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $aa95bf9e76b6b9cc$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...baseColors,
        cursor: 'pointer',
        height: $aa95bf9e76b6b9cc$var$heights[spacing],
        lineHeight: $aa95bf9e76b6b9cc$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $aa95bf9e76b6b9cc$var$singleIconPadding[spacing] : $aa95bf9e76b6b9cc$var$padding[spacing],
        verticalAlign: $aa95bf9e76b6b9cc$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        '&:visited': {
            ...baseColors
        },
        '&:hover': {
            ...$aa95bf9e76b6b9cc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'hover',
                mode: mode
            }),
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        },
        // giving active styles preference by listing them after focus
        '&:active': {
            ...$aa95bf9e76b6b9cc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'active',
                mode: mode
            }),
            // background, box-shadow
            transitionDuration: '0s, 0s'
        },
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': {
            ...$aa95bf9e76b6b9cc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'active',
                mode: mode
            }),
            // background, box-shadow
            transitionDuration: '0s, 0s'
        },
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': {
            // always using 'disabled' even when selected
            ...$aa95bf9e76b6b9cc$var$getColors({
                appearance: appearance,
                key: 'disabled',
                mode: mode
            }),
            cursor: 'not-allowed',
            textDecoration: 'none'
        },
        '&[data-has-overlay="true"]': {
            cursor: 'default',
            textDecoration: 'none'
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            ...$aa95bf9e76b6b9cc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'default',
                mode: mode
            })
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $aa95bf9e76b6b9cc$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $aa95bf9e76b6b9cc$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $aa95bf9e76b6b9cc$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $aa95bf9e76b6b9cc$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $aa95bf9e76b6b9cc$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $aa95bf9e76b6b9cc$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("kl686", function(module, exports) {

$parcel$export(module.exports, "default", () => $83da58c76f5b549e$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $83da58c76f5b549e$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $83da58c76f5b549e$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-neutral, ${$PdmhA.DN70})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$PdmhA.N30A})`,
                dark: `var(--ds-background-neutral-hovered, ${$PdmhA.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$83da58c76f5b549e$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$PdmhA.B75})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$PdmhA.B400})`,
                dark: `var(--ds-background-brand-bold, ${$PdmhA.B100})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$PdmhA.B300})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$PdmhA.B75})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$PdmhA.B500})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$PdmhA.B200})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$PdmhA.Y300})`,
                dark: `var(--ds-background-warning-bold, ${$PdmhA.Y300})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$PdmhA.Y200})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$PdmhA.Y200})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$PdmhA.Y400})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-selected, ${$PdmhA.Y400})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-selected, ${$PdmhA.Y400})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$PdmhA.R400})`,
                dark: `var(--ds-background-danger-bold, ${$PdmhA.R400})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$PdmhA.R300})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$PdmhA.R300})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$PdmhA.R500})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$PdmhA.R500})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.R500})`,
                dark: `var(--ds-background-selected, ${$PdmhA.R500})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.R500})`,
                dark: `var(--ds-background-selected, ${$PdmhA.R500})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.N30A})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$83da58c76f5b549e$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$PdmhA.B75})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$PdmhA.N500})`,
                dark: `var(--ds-text, ${$PdmhA.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.B400})`,
                dark: `var(--ds-text, ${$PdmhA.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$PdmhA.N0})`,
                dark: `var(--ds-text-inverse, ${$PdmhA.DN30})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$PdmhA.N800})`,
                dark: `var(--ds-text-warning-inverse, ${$PdmhA.N800})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N800})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N800})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N800})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N800})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$PdmhA.N0})`,
                dark: `var(--ds-text-inverse, ${$PdmhA.N0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N0})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N0})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N0})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N0})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$PdmhA.B400})`,
                dark: `var(--ds-link, ${$PdmhA.B100})`
            },
            hover: {
                light: `var(--ds-link, ${$PdmhA.B300})`,
                dark: `var(--ds-link, ${$PdmhA.B75})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$PdmhA.B500})`,
                dark: `var(--ds-link-pressed, ${$PdmhA.B200})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N700})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N700})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$PdmhA.N500})`,
                dark: `var(--ds-text, ${$PdmhA.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.B400})`,
                dark: `var(--ds-text, ${$PdmhA.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$PdmhA.N200})`,
                dark: `var(--ds-text-subtle, ${$PdmhA.DN400})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$PdmhA.N90})`,
                dark: `var(--ds-text-subtle, ${$PdmhA.B50})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.N400})`,
                dark: `var(--ds-text, ${$PdmhA.DN300})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        }
    }
};
var $83da58c76f5b549e$export$2e2bcd8739ae039 = $83da58c76f5b549e$var$values;

});


parcelRegister("aUI58", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $c47e4826ffcdb5ea$export$20bbd2efb0d734c4);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");
const $c47e4826ffcdb5ea$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eUqFw.isValidElement)(children) && children.type === (0, $lkPEe.default);
};

});
parcelRegister("lkPEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3566ce4aab60e480$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $3566ce4aab60e480$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
const $3566ce4aab60e480$var$visuallyHiddenStyles = {
    name: "19natlh",
    styles: "width:1px;height:1px;padding:0;position:absolute;border:0;clip:rect(1px, 1px, 1px, 1px);overflow:hidden;white-space:nowrap"
};
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $3566ce4aab60e480$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $3566ce4aab60e480$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $3566ce4aab60e480$export$2e2bcd8739ae039 = $3566ce4aab60e480$var$VisuallyHidden;

});



parcelRegister("jRP2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe99a6cb8335ab35$export$2e2bcd8739ae039);

var $aUI58 = parcelRequire("aUI58");
function $fe99a6cb8335ab35$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $aUI58.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("7opLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9480cdd411b448c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lP3nh = parcelRequire("lP3nh");
/**
 * __Loading button__
 *
 * CAUTION: Legacy loading buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $9480cdd411b448c0$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lP3nh.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$9480cdd411b448c0$var$LoadingButton.displayName = 'LoadingButton';
var $9480cdd411b448c0$export$2e2bcd8739ae039 = $9480cdd411b448c0$var$LoadingButton;

});
parcelRegister("lP3nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a10a83cfe0efde6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");
function $4a10a83cfe0efde6$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $4a10a83cfe0efde6$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: size,
        label: ", Loading",
        appearance: $4a10a83cfe0efde6$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("4Bees", function(module, exports) {

$parcel$export(module.exports, "default", () => $eac79f4bf1eea2b4$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jsCXU = parcelRequire("jsCXU");

var $PdmhA = parcelRequire("PdmhA");

var $d3gVI = parcelRequire("d3gVI");
function $eac79f4bf1eea2b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Returns the appropriate circle stroke color.
 */ function $eac79f4bf1eea2b4$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? `var(--ds-icon-subtle, ${0, $PdmhA.N500})` : `var(--ds-icon-inverse, ${0, $PdmhA.N0})`;
}
const $eac79f4bf1eea2b4$var$rotate = (0, $byn9U.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
const $eac79f4bf1eea2b4$var$rotateStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$eac79f4bf1eea2b4$var$rotate} 0.86s infinite`,
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ const $eac79f4bf1eea2b4$var$loadIn = (0, $byn9U.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
const $eac79f4bf1eea2b4$var$loadInStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$eac79f4bf1eea2b4$var$loadIn} 1s ease-in-out`,
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
const $eac79f4bf1eea2b4$var$wrapperStyles = {
    name: "1l7iyxt",
    styles: "display:inline-flex;vertical-align:middle"
};
const $eac79f4bf1eea2b4$var$circleStyles = {
    name: "1qav847",
    styles: "fill:none;stroke-dasharray:60;stroke-dashoffset:inherit;stroke-linecap:round;stroke-width:1.5;@media screen and (forced-colors: active){filter:grayscale(100%);stroke:CanvasText;}"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $eac79f4bf1eea2b4$var$useLayoutEffect = typeof window === 'undefined' ? (0, $eUqFw.useEffect) : (0, $eUqFw.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/{spinner}/examples)
 * - [Code](https://atlassian.design/components/{spinner}/code)
 * - [Usage](https://atlassian.design/components/{spinner}/usage)
 */ const $eac79f4bf1eea2b4$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $d3gVI.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $eac79f4bf1eea2b4$var$getStrokeColor(appearance);
    const context = (0, $eUqFw.useContext)((0, $jsCXU.default));
    $eac79f4bf1eea2b4$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ css: [
            $eac79f4bf1eea2b4$var$wrapperStyles,
            $eac79f4bf1eea2b4$var$rotateStyles
        ],
        "data-testid": testId && `${testId}-wrapper`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $eac79f4bf1eea2b4$var$loadInStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, /*#__PURE__*/ (0, $byn9U.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $eac79f4bf1eea2b4$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $eac79f4bf1eea2b4$export$2e2bcd8739ae039 = $eac79f4bf1eea2b4$var$Spinner;

});
parcelRegister("d3gVI", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $2de05b92b3a2dbf9$export$4e9f1640bbe7a1a8);
const $2de05b92b3a2dbf9$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("bbaTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d5e59a79167b73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6rmE5 = parcelRequire("6rmE5");

var $lHbz7 = parcelRequire("lHbz7");

var $jRP2t = parcelRequire("jRP2t");

var $lP3nh = parcelRequire("lP3nh");

var $Sibrq = parcelRequire("Sibrq");
function $d3d5e59a79167b73$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $d3d5e59a79167b73$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $d3d5e59a79167b73$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $Sibrq.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $eUqFw.useState)($d3d5e59a79167b73$var$initial);
    const onMouseEnter = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Sibrq.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6rmE5.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Sibrq.default).Consumer, {
            mode: mode,
            state: $d3d5e59a79167b73$var$getInteractionState({
                ...state,
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            }),
            iconIsOnlyChild: (0, $jRP2t.default)(restProps),
            isLoading: isLoading,
            ...restProps
        }, ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lHbz7.default), {
                ...restProps,
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lP3nh.default), restProps) : null,
                // No need to render aria-disabled when it is false
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $Sibrq.getSpecifiers)(buttonStyles)
            }))));
}));
// Tools including enzyme rely on components having a display name
$d3d5e59a79167b73$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $d3d5e59a79167b73$export$2e2bcd8739ae039 = $d3d5e59a79167b73$var$CustomThemeButton;

});
parcelRegister("Sibrq", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", () => $951a33d68b9a2483$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $951a33d68b9a2483$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $951a33d68b9a2483$export$2e2bcd8739ae039);

var $jQBE2 = parcelRequire("jQBE2");

var $dvp51 = parcelRequire("dvp51");
const $951a33d68b9a2483$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $951a33d68b9a2483$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $dvp51.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $951a33d68b9a2483$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $951a33d68b9a2483$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $951a33d68b9a2483$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $951a33d68b9a2483$var$Theme = (0, $jQBE2.createTheme)((themeProps)=>({
        buttonStyles: $951a33d68b9a2483$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$951a33d68b9a2483$export$2e2bcd8739ae039 = $951a33d68b9a2483$var$Theme;

});


parcelRegister("bLFgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2d73e65dd4884c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $ee2d73e65dd4884c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ee2d73e65dd4884c$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $ee2d73e65dd4884c$export$2e2bcd8739ae039({ appearance: appearance, children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ee2d73e65dd4884c$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: idx
        }, appearance ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});


parcelRegister("kjiJx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("4Bees")).default);

var $4Bees = parcelRequire("4Bees");

});

parcelRegister("dcbVh", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("cR7hG")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("cR7hG")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("5wCOA")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("5wCOA")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("dlE38")).EDITOR_CONTEXT);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => (parcelRequire("dlE38")).EDITOR_APPEARANCE_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("dlE38")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $6bb2437d634f2335$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("48k2V")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("48k2V")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("8N29D")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("8N29D")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("gjC6M")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("gjC6M")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("fZ5Cn")).ATLAS_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("hw8rx")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("cMbrx")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("eUjFK")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("6dMJ8")).AVP_CONTEXT);

var $cR7hG = parcelRequire("cR7hG");

var $5wCOA = parcelRequire("5wCOA");

var $dlE38 = parcelRequire("dlE38");


var $48k2V = parcelRequire("48k2V");

var $8N29D = parcelRequire("8N29D");

var $gjC6M = parcelRequire("gjC6M");

var $fZ5Cn = parcelRequire("fZ5Cn");

var $hw8rx = parcelRequire("hw8rx");

var $cMbrx = parcelRequire("cMbrx");

var $eUjFK = parcelRequire("eUjFK");

var $6dMJ8 = parcelRequire("6dMJ8");

});
parcelRegister("cR7hG", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $155ed896864cf66b$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $155ed896864cf66b$export$3fe25500478a635c);

var $hKkEL = parcelRequire("hKkEL");
const $155ed896864cf66b$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $155ed896864cf66b$export$3fe25500478a635c = (0, $hKkEL.default)($155ed896864cf66b$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("hKkEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6943433ee598b71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $f6943433ee598b71$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $f6943433ee598b71$export$2e2bcd8739ae039 = $f6943433ee598b71$var$createNamespaceContext;

});
parcelRegister("aw5Sy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7662074161bb207$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $8PMUi = parcelRequire("8PMUi");

var $2BBco = parcelRequire("2BBco");

var $2fFJv = parcelRequire("2fFJv");
const $a7662074161bb207$var$ExportedAnalyticsContext = (props)=>{
    const isModernContextEnabledEnv = typeof $2fFJv !== 'undefined' && $2fFJv !== null && $2fFJv.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
    return isModernContextEnabledEnv || (0, $XHGTv.getBooleanFF)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2BBco.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PMUi.default), props);
};
var $a7662074161bb207$export$2e2bcd8739ae039 = $a7662074161bb207$var$ExportedAnalyticsContext;

});
parcelRegister("8PMUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e545033c7a8ba31f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $kNx8v = parcelRequire("kNx8v");
const $e545033c7a8ba31f$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
const $e545033c7a8ba31f$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e545033c7a8ba31f$var$AnalyticsContext extends (0, $eUqFw.Component) {
    static{
        this.contextTypes = $e545033c7a8ba31f$var$ContextTypes;
    }
    static{
        this.childContextTypes = $e545033c7a8ba31f$var$ContextTypes;
    }
    constructor(props){
        super(props);
        this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            });
        this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $e545033c7a8ba31f$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        };
        this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $e545033c7a8ba31f$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNx8v.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $e545033c7a8ba31f$export$2e2bcd8739ae039 = $e545033c7a8ba31f$var$AnalyticsContext;

});

parcelRegister("2BBco", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde67f2c03c1506f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kNx8v = parcelRequire("kNx8v");

var $369Kv = parcelRequire("369Kv");

var $gNgZO = parcelRequire("gNgZO");
const $dde67f2c03c1506f$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $gNgZO.useTrackedRef)(data);
    const analyticsContext = (0, $369Kv.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $eUqFw.useCallback)(()=>{
        return [
            ...analyticsContext.getAtlaskitAnalyticsContext(),
            dataRef.current
        ];
    }, [
        analyticsContext,
        dataRef
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        }), [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNx8v.default).Provider, {
        value: value
    }, children);
};
var $dde67f2c03c1506f$export$2e2bcd8739ae039 = $dde67f2c03c1506f$var$AnalyticsContext;

});




parcelRegister("5wCOA", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $d9cb7df193e79e88$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $d9cb7df193e79e88$export$d0a82da1a0b94929);

var $hKkEL = parcelRequire("hKkEL");
const $d9cb7df193e79e88$export$1fd3aad76a7c6788 = 'navigationCtx';
const $d9cb7df193e79e88$export$d0a82da1a0b94929 = (0, $hKkEL.default)($d9cb7df193e79e88$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("dlE38", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CONTEXT", () => $5345aff31d593619$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $5345aff31d593619$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $5345aff31d593619$export$629cada6c5e621e1);

var $hKkEL = parcelRequire("hKkEL");
const $5345aff31d593619$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $5345aff31d593619$export$9eb2b47430ed3f7c;
(function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
})($5345aff31d593619$export$9eb2b47430ed3f7c || ($5345aff31d593619$export$9eb2b47430ed3f7c = {}));
const $5345aff31d593619$export$629cada6c5e621e1 = (0, $hKkEL.default)($5345aff31d593619$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("48k2V", function(module, exports) {

$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $7da342658d66899e$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $7da342658d66899e$export$4119ddb38ccbfb87);

var $hKkEL = parcelRequire("hKkEL");
const $7da342658d66899e$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $7da342658d66899e$export$4119ddb38ccbfb87 = (0, $hKkEL.default)($7da342658d66899e$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("8N29D", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $b83b73628934f989$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $b83b73628934f989$export$6f8e7ff1e3feafd7);

var $hKkEL = parcelRequire("hKkEL");
const $b83b73628934f989$export$da1befb791e93c7e = 'NotificationsCtx';
const $b83b73628934f989$export$6f8e7ff1e3feafd7 = (0, $hKkEL.default)($b83b73628934f989$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("gjC6M", function(module, exports) {

$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $2d74341134511809$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $2d74341134511809$export$745926731087ebe2);

var $hKkEL = parcelRequire("hKkEL");
const $2d74341134511809$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $2d74341134511809$export$745926731087ebe2 = (0, $hKkEL.default)($2d74341134511809$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("fZ5Cn", function(module, exports) {

$parcel$export(module.exports, "ATLAS_CONTEXT", () => $5febb48d67d386ec$export$4906017439f33fc0);

var $hKkEL = parcelRequire("hKkEL");
const $5febb48d67d386ec$export$4906017439f33fc0 = 'atlasCtx';
const $5febb48d67d386ec$export$43ebbe41370d4543 = (0, $hKkEL.default)($5febb48d67d386ec$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("hw8rx", function(module, exports) {

$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $a4ac324e0c37bd6b$export$3240443bf2b83834);

var $hKkEL = parcelRequire("hKkEL");
const $a4ac324e0c37bd6b$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $a4ac324e0c37bd6b$export$6d568da622ce0a08 = (0, $hKkEL.default)($a4ac324e0c37bd6b$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("cMbrx", function(module, exports) {

$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $4d79d69072e02cd9$export$ef0c05448f0f8f9);

var $hKkEL = parcelRequire("hKkEL");
const $4d79d69072e02cd9$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $4d79d69072e02cd9$export$dcd232f3be312f94 = (0, $hKkEL.default)($4d79d69072e02cd9$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("eUjFK", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $eeeb009c1a918308$export$5c3a6fd8b96e8b66);

var $hKkEL = parcelRequire("hKkEL");
const $eeeb009c1a918308$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $eeeb009c1a918308$export$de3826c30468da26 = (0, $hKkEL.default)($eeeb009c1a918308$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("6dMJ8", function(module, exports) {

$parcel$export(module.exports, "AVP_CONTEXT", () => $f74c3ee9341daef6$export$c2a811a4e42f4af5);

var $hKkEL = parcelRequire("hKkEL");
const $f74c3ee9341daef6$export$c2a811a4e42f4af5 = 'avpCtx';
const $f74c3ee9341daef6$export$da383e8879a25b03 = (0, $hKkEL.default)($f74c3ee9341daef6$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});


parcelRegister("6PJBT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fNgZb")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("lBbBq")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("88sYM")).FabricChannel);

var $fNgZb = parcelRequire("fNgZb");

var $lBbBq = parcelRequire("lBbBq");

var $88sYM = parcelRequire("88sYM");

});
parcelRegister("fNgZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ce488d0ac854330$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $63WKU = parcelRequire("63WKU");

var $5svIB = parcelRequire("5svIB");

var $lBbBq = parcelRequire("lBbBq");

var $ib4md = parcelRequire("ib4md");

var $5HFr7 = parcelRequire("5HFr7");

var $b7eP2 = parcelRequire("b7eP2");

var $hb1kz = parcelRequire("hb1kz");

var $gs8Ul = parcelRequire("gs8Ul");

var $brbwc = parcelRequire("brbwc");

var $aRMOt = parcelRequire("aRMOt");

var $iUFkZ = parcelRequire("iUFkZ");

var $bZLJL = parcelRequire("bZLJL");

var $eDdgN = parcelRequire("eDdgN");

var $h0SFW = parcelRequire("h0SFW");

var $6b9CA = parcelRequire("6b9CA");
const $1ce488d0ac854330$var$listenerMap = {
    [(0, $88sYM.FabricChannel).elements]: (0, $63WKU.default),
    [(0, $88sYM.FabricChannel).editor]: (0, $5HFr7.default),
    [(0, $88sYM.FabricChannel).atlaskit]: (0, $5svIB.default),
    [(0, $88sYM.FabricChannel).navigation]: (0, $ib4md.default),
    [(0, $88sYM.FabricChannel).media]: (0, $b7eP2.default),
    [(0, $88sYM.FabricChannel).peopleTeams]: (0, $hb1kz.default),
    [(0, $88sYM.FabricChannel).notifications]: (0, $gs8Ul.default),
    [(0, $88sYM.FabricChannel).recentWork]: (0, $brbwc.default),
    [(0, $88sYM.FabricChannel).atlas]: (0, $aRMOt.default),
    [(0, $88sYM.FabricChannel).crossFlow]: (0, $iUFkZ.default),
    [(0, $88sYM.FabricChannel).linkingPlatform]: (0, $bZLJL.default),
    [(0, $88sYM.FabricChannel).postOffice]: (0, $eDdgN.default),
    [(0, $88sYM.FabricChannel).aiMate]: (0, $h0SFW.default),
    [(0, $88sYM.FabricChannel).avp]: (0, $6b9CA.default)
};
class $1ce488d0ac854330$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $lBbBq.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($1ce488d0ac854330$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$1ce488d0ac854330$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Listener, {
                client: client,
                logger: this.logger
            }, prev), children);
        return listeners;
    }
}
var $1ce488d0ac854330$export$2e2bcd8739ae039 = $1ce488d0ac854330$var$FabricAnalyticsListeners;

});
parcelRegister("88sYM", function(module, exports) {

$parcel$export(module.exports, "FabricChannel", () => $c138900dd66fbd1c$export$8faa0b115ef0268b);
var $c138900dd66fbd1c$export$8faa0b115ef0268b;
(function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
})($c138900dd66fbd1c$export$8faa0b115ef0268b || ($c138900dd66fbd1c$export$8faa0b115ef0268b = {}));

});

parcelRegister("63WKU", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_TAG", () => $b82780a8a4e8128a$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $b82780a8a4e8128a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $88sYM = parcelRequire("88sYM");

var $b4P4o = parcelRequire("b4P4o");
const $b82780a8a4e8128a$export$ed71ae78997933a = 'fabricElements';
class $b82780a8a4e8128a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $88sYM.FabricChannel).elements
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $b4P4o.handleEvent)(event, $b82780a8a4e8128a$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("jYVKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5754ec732cf0db7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $5ZgZX = parcelRequire("5ZgZX");

var $6EGCa = parcelRequire("6EGCa");

var $2fFJv = parcelRequire("2fFJv");
const $5754ec732cf0db7a$var$ExportedAnalyticsListener = (props)=>{
    const isModernContextEnabledEnv = typeof $2fFJv !== 'undefined' && $2fFJv !== null && $2fFJv.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
    return isModernContextEnabledEnv || (0, $XHGTv.getBooleanFF)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EGCa.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZgZX.default), props);
};
var $5754ec732cf0db7a$export$2e2bcd8739ae039 = $5754ec732cf0db7a$var$ExportedAnalyticsListener;

});
parcelRegister("5ZgZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $176fe25f9e21d1e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $kNx8v = parcelRequire("kNx8v");
const $176fe25f9e21d1e3$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
const $176fe25f9e21d1e3$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $176fe25f9e21d1e3$var$AnalyticsListener extends (0, $eUqFw.Component) {
    static{
        this.contextTypes = $176fe25f9e21d1e3$var$ContextTypes;
    }
    static{
        this.childContextTypes = $176fe25f9e21d1e3$var$ContextTypes;
    }
    constructor(props){
        super(props);
        this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            });
        this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $176fe25f9e21d1e3$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        };
        this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $176fe25f9e21d1e3$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNx8v.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $176fe25f9e21d1e3$export$2e2bcd8739ae039 = $176fe25f9e21d1e3$var$AnalyticsListener;

});

parcelRegister("6EGCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $047308b1d19a5c44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kNx8v = parcelRequire("kNx8v");

var $369Kv = parcelRequire("369Kv");

var $gNgZO = parcelRequire("gNgZO");
const $047308b1d19a5c44$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const analyticsContext = (0, $369Kv.useAnalyticsContext)();
    const onEventRef = (0, $gNgZO.useTrackedRef)(onEvent);
    const channelRef = (0, $gNgZO.useTrackedRef)(channel);
    const getAtlaskitAnalyticsEventHandlers = (0, $eUqFw.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            ...analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            thisHandler
        ];
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    const value = (0, $eUqFw.useMemo)(()=>{
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNx8v.default).Provider, {
        value: value
    }, children);
};
var $047308b1d19a5c44$export$2e2bcd8739ae039 = $047308b1d19a5c44$var$AnalyticsListener;

});


parcelRegister("b4P4o", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $64b05d1e2dd77cb2$export$d6e5ca10785815df);

var $gNfBM = parcelRequire("gNfBM");

var $Yo7M1 = parcelRequire("Yo7M1");
const $64b05d1e2dd77cb2$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $Yo7M1.processEventPayload)(event, tags);
    (0, $gNfBM.sendEvent)(logger, client)(payload);
};

});
parcelRegister("gNfBM", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $f6b1e9d8c0f41dbf$export$7329bcdc3edcd90e);
const $f6b1e9d8c0f41dbf$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $f6b1e9d8c0f41dbf$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($f6b1e9d8c0f41dbf$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("Yo7M1", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $cdc18c5836d8bdbf$export$c37d638b7f2ca192);

parcelRequire("dcbVh");
var $dlE38 = parcelRequire("dlE38");
var $cR7hG = parcelRequire("cR7hG");

var $2vzCR = parcelRequire("2vzCR");

var $63WKU = parcelRequire("63WKU");

var $5HFr7 = parcelRequire("5HFr7");
const $cdc18c5836d8bdbf$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, item), {});
const $cdc18c5836d8bdbf$var$fieldExtractor = (contextKey)=>$cdc18c5836d8bdbf$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $cdc18c5836d8bdbf$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $63WKU.ELEMENTS_TAG:
            return 0, $cR7hG.ELEMENTS_CONTEXT;
        case 0, $5HFr7.EDITOR_TAG:
            return 0, $dlE38.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $cdc18c5836d8bdbf$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $cdc18c5836d8bdbf$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $cdc18c5836d8bdbf$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $cdc18c5836d8bdbf$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $cdc18c5836d8bdbf$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $cdc18c5836d8bdbf$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $cdc18c5836d8bdbf$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$cdc18c5836d8bdbf$var$updatePayloadWithContext(primaryTag, event),
        tags: $cdc18c5836d8bdbf$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

parcelRegister("5HFr7", function(module, exports) {

$parcel$export(module.exports, "EDITOR_TAG", () => $4d5195cb36d09726$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $4d5195cb36d09726$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $88sYM = parcelRequire("88sYM");

var $b4P4o = parcelRequire("b4P4o");
const $4d5195cb36d09726$export$a1d9dc589a29b3aa = 'editor';
const $4d5195cb36d09726$export$8aa0d788f94a809 = 'fabricEditor';
class $4d5195cb36d09726$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $88sYM.FabricChannel).editor
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $b4P4o.handleEvent)(event, [
                $4d5195cb36d09726$export$a1d9dc589a29b3aa,
                $4d5195cb36d09726$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("5svIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $988614d990809fff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $lFK0K = parcelRequire("lFK0K");

var $eX1OM = parcelRequire("eX1OM");
function $988614d990809fff$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).atlaskit,
        processEvent: (0, $lFK0K.default)
    });
}

});
parcelRegister("lFK0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4321c07a8c83464$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");


var $iBftd = parcelRequire("iBftd");
const $e4321c07a8c83464$var$ATLASKIT_TAG = 'atlaskit';
const $e4321c07a8c83464$var$listenerVersion = undefined;
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e4321c07a8c83464$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $iBftd.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $iBftd.getExtraAttributes)(event);
    const components = (0, $iBftd.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $iBftd.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $e4321c07a8c83464$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $iBftd.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e4321c07a8c83464$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $662e33bb7444ae33$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $iBftd.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $662e33bb7444ae33$export$947dac6c72b26f81) || eventType === (0, $662e33bb7444ae33$export$12346a674644c156) || eventType === (0, $662e33bb7444ae33$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("iBftd", function(module, exports) {

$parcel$export(module.exports, "extractFromEventContext", () => $19b06eca3690875d$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $19b06eca3690875d$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $19b06eca3690875d$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $19b06eca3690875d$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $19b06eca3690875d$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $19b06eca3690875d$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $19b06eca3690875d$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $2vzCR = parcelRequire("2vzCR");
const $19b06eca3690875d$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $19b06eca3690875d$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $19b06eca3690875d$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $19b06eca3690875d$export$5f9bc633b116660f = (event)=>$19b06eca3690875d$export$9b947b4502cd2705('source', event);
const $19b06eca3690875d$export$4e811121b221213b = (event)=>$19b06eca3690875d$export$9b947b4502cd2705('component', event);
const $19b06eca3690875d$export$67c3590839ebecdd = (event)=>$19b06eca3690875d$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraAttributes), {});
const $19b06eca3690875d$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $19b06eca3690875d$export$18cd124b5098d330 = (event)=>$19b06eca3690875d$export$9b947b4502cd2705('packageVersion', event);
function $19b06eca3690875d$export$4e0b83da1896ebc7(event) {
    const packages = $19b06eca3690875d$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("eX1OM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df599e0b24980e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $gNfBM = parcelRequire("gNfBM");
class $9df599e0b24980e1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $gNfBM.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("lBbBq", function(module, exports) {

$parcel$export(module.exports, "LOG_LEVEL", () => $f16b21601e106529$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $f16b21601e106529$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $f16b21601e106529$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $f16b21601e106529$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $f16b21601e106529$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $f16b21601e106529$export$ffe0c436e29512cf.DEBUG && logLevel <= $f16b21601e106529$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $f16b21601e106529$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($f16b21601e106529$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($f16b21601e106529$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($f16b21601e106529$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($f16b21601e106529$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("ib4md", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97bf3e946425ee4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $5XQ5o = parcelRequire("5XQ5o");

var $eX1OM = parcelRequire("eX1OM");
function $b97bf3e946425ee4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).navigation,
        processEvent: (0, $5XQ5o.default)
    });
}

});
parcelRegister("5XQ5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $94aa756e6be235b2$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $5wCOA = parcelRequire("5wCOA");

var $ia05w = parcelRequire("ia05w");
const $94aa756e6be235b2$var$NAVIGATION_TAG = 'navigation';
const $94aa756e6be235b2$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $94aa756e6be235b2$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $5wCOA.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $5wCOA.NAVIGATION_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $5wCOA.NAVIGATION_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $5wCOA.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $5wCOA.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $94aa756e6be235b2$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($94aa756e6be235b2$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            logger.error('Track events are currently not supported for navigation events');
            break;
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("ia05w", function(module, exports) {

$parcel$export(module.exports, "getSources", () => $95511831b1da0f19$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $95511831b1da0f19$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $95511831b1da0f19$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $95511831b1da0f19$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $2vzCR = parcelRequire("2vzCR");
const $95511831b1da0f19$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $95511831b1da0f19$export$5f9bc633b116660f = (event, contextName)=>$95511831b1da0f19$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $95511831b1da0f19$export$4e811121b221213b = (event, contextName)=>$95511831b1da0f19$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $95511831b1da0f19$export$67c3590839ebecdd = (event, contextName)=>$95511831b1da0f19$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraAttributes), {});
const $95511831b1da0f19$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $95511831b1da0f19$export$18cd124b5098d330 = (event, contextName)=>$95511831b1da0f19$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("b7eP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c01f6e9a21ba257e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $4RXW0 = parcelRequire("4RXW0");

var $eX1OM = parcelRequire("eX1OM");
function $c01f6e9a21ba257e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).media,
        processEvent: (0, $4RXW0.processEvent)
    });
}

});
parcelRegister("4RXW0", function(module, exports) {

$parcel$export(module.exports, "processEvent", () => $1559d8011ab7e472$export$22af68e3614bf024);

parcelRequire("dcbVh");

var $2vzCR = parcelRequire("2vzCR");

var $iTvqy = parcelRequire("iTvqy");

var $iBftd = parcelRequire("iBftd");
const $1559d8011ab7e472$var$listenerVersion = undefined;
function $1559d8011ab7e472$var$getMediaContexts(event) {
    return (0, $iBftd.extractFromEventContext)((0, $6bb2437d634f2335$export$70df29c238ba7306), event);
}
function $1559d8011ab7e472$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $1559d8011ab7e472$export$22af68e3614bf024(event) {
    const sources = (0, $iBftd.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $iBftd.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $iBftd.getExtraAttributes)(event);
    const mediaContexts = $1559d8011ab7e472$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $iBftd.getComponents)(event);
    const mediaRegion = $1559d8011ab7e472$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $iBftd.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $1559d8011ab7e472$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        }
    };
    return payload;
}

});


parcelRegister("hb1kz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46176a6bea809c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $2deYs = parcelRequire("2deYs");

var $eX1OM = parcelRequire("eX1OM");
function $a46176a6bea809c0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).peopleTeams,
        processEvent: (0, $2deYs.default)
    });
}

});
parcelRegister("2deYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $eac902d5212c2d6f$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $48k2V = parcelRequire("48k2V");

var $ia05w = parcelRequire("ia05w");
const $eac902d5212c2d6f$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $eac902d5212c2d6f$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $eac902d5212c2d6f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $48k2V.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $48k2V.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $48k2V.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $48k2V.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $48k2V.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $eac902d5212c2d6f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($eac902d5212c2d6f$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("gs8Ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3ad658f6f1cef4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $c3bgE = parcelRequire("c3bgE");

var $eX1OM = parcelRequire("eX1OM");
function $ba3ad658f6f1cef4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).notifications,
        processEvent: (0, $c3bgE.default)
    });
}

});
parcelRegister("c3bgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ff1b1c01722309$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");


var $ia05w = parcelRequire("ia05w");
parcelRequire("dcbVh");
var $8N29D = parcelRequire("8N29D");

var $88sYM = parcelRequire("88sYM");
const $a0ff1b1c01722309$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $a0ff1b1c01722309$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $8N29D.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $8N29D.NOTIFICATIONS_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $8N29D.NOTIFICATIONS_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $8N29D.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $8N29D.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $a0ff1b1c01722309$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $88sYM.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("brbwc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36e8575c31248e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $jK3H9 = parcelRequire("jK3H9");

var $eX1OM = parcelRequire("eX1OM");
function $c36e8575c31248e3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).recentWork,
        processEvent: (0, $jK3H9.default)
    });
}

});
parcelRegister("jK3H9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6deea1c93e6a0d8$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");


var $ia05w = parcelRequire("ia05w");
parcelRequire("dcbVh");
var $gjC6M = parcelRequire("gjC6M");

var $88sYM = parcelRequire("88sYM");
const $f6deea1c93e6a0d8$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $f6deea1c93e6a0d8$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $gjC6M.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $gjC6M.RECENT_WORK_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $gjC6M.RECENT_WORK_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $gjC6M.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $gjC6M.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f6deea1c93e6a0d8$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $88sYM.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("aRMOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61520663a671872$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $3mTav = parcelRequire("3mTav");

var $eX1OM = parcelRequire("eX1OM");
function $a61520663a671872$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).atlas,
        processEvent: (0, $3mTav.default)
    });
}

});
parcelRegister("3mTav", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd1313d83c5e0c0$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");


var $ia05w = parcelRequire("ia05w");
parcelRequire("dcbVh");
var $fZ5Cn = parcelRequire("fZ5Cn");
const $fcd1313d83c5e0c0$var$ATLAS_TAG = 'atlas';
const $fcd1313d83c5e0c0$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $fcd1313d83c5e0c0$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $fZ5Cn.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $fZ5Cn.ATLAS_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $fZ5Cn.ATLAS_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $fZ5Cn.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $fZ5Cn.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $fcd1313d83c5e0c0$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($fcd1313d83c5e0c0$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("iUFkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2440e871658f3e76$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $5IfU4 = parcelRequire("5IfU4");

var $eX1OM = parcelRequire("eX1OM");
function $2440e871658f3e76$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).crossFlow,
        processEvent: (0, $5IfU4.default)
    });
}

});
parcelRegister("5IfU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92520d74f7a924e$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 

var $iTvqy = parcelRequire("iTvqy");
parcelRequire("dcbVh");
var $5wCOA = parcelRequire("5wCOA");

var $iBftd = parcelRequire("iBftd");

var $ia05w = parcelRequire("ia05w");
const $e92520d74f7a924e$var$CROSS_FLOW_TAG = 'crossFlow';
var $e92520d74f7a924e$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $iBftd.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $iBftd.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $ia05w.getExtraAttributes)(event, (0, $5wCOA.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e92520d74f7a924e$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("bZLJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf01d628281767c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2DrwS = parcelRequire("2DrwS");

var $88sYM = parcelRequire("88sYM");

var $eX1OM = parcelRequire("eX1OM");
function $fcf01d628281767c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).linkingPlatform,
        processEvent: (0, $2DrwS.default)
    });
}

});
parcelRegister("2DrwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc0b551e8359d71$export$2e2bcd8739ae039);

var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $hw8rx = parcelRequire("hw8rx");

var $ia05w = parcelRequire("ia05w");

var $88sYM = parcelRequire("88sYM");
const $8bc0b551e8359d71$var$listenerVersion = undefined;
var $8bc0b551e8359d71$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $hw8rx.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $hw8rx.LINKING_PLATFORM_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $hw8rx.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $hw8rx.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $88sYM.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $8bc0b551e8359d71$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("eDdgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a70c875d6e679$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $jRzgy = parcelRequire("jRzgy");

var $eX1OM = parcelRequire("eX1OM");
function $b29a70c875d6e679$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).postOffice,
        processEvent: (0, $jRzgy.default)
    });
}

});
parcelRegister("jRzgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b18b3be93f78156$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $cMbrx = parcelRequire("cMbrx");

var $ia05w = parcelRequire("ia05w");

var $88sYM = parcelRequire("88sYM");
const $4b18b3be93f78156$var$POST_OFFICE_TAG = (0, $88sYM.FabricChannel).postOffice;
const $4b18b3be93f78156$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4b18b3be93f78156$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $cMbrx.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $cMbrx.POST_OFFICE_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $cMbrx.POST_OFFICE_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $cMbrx.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $cMbrx.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4b18b3be93f78156$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4b18b3be93f78156$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("h0SFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $845c633a937be8a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $4llcJ = parcelRequire("4llcJ");

var $eX1OM = parcelRequire("eX1OM");
function $845c633a937be8a4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).aiMate,
        processEvent: (0, $4llcJ.default)
    });
}

});
parcelRegister("4llcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c473e7a91d374d4$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $eUjFK = parcelRequire("eUjFK");

var $ia05w = parcelRequire("ia05w");
const $9c473e7a91d374d4$var$AI_MATE_TAG = 'aiMate';
const $9c473e7a91d374d4$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $9c473e7a91d374d4$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $eUjFK.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $eUjFK.AI_MATE_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $eUjFK.AI_MATE_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $eUjFK.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $eUjFK.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9c473e7a91d374d4$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($9c473e7a91d374d4$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("6b9CA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4ffb40dc702571$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $88sYM = parcelRequire("88sYM");

var $48r9d = parcelRequire("48r9d");

var $eX1OM = parcelRequire("eX1OM");
function $3c4ffb40dc702571$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX1OM.default), {
        ...props,
        channel: (0, $88sYM.FabricChannel).avp,
        processEvent: (0, $48r9d.default)
    });
}

});
parcelRegister("48r9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2137422a7f16ea46$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

parcelRequire("dcbVh");
var $6dMJ8 = parcelRequire("6dMJ8");

var $ia05w = parcelRequire("ia05w");
const $2137422a7f16ea46$var$AVP_TAG = 'avp';
const $2137422a7f16ea46$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $2137422a7f16ea46$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ia05w.getSources)(event, (0, $6dMJ8.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = (0, $ia05w.getExtraAttributes)(event, (0, $6dMJ8.AVP_CONTEXT));
    const components = (0, $ia05w.getComponents)(event, (0, $6dMJ8.AVP_CONTEXT));
    const packages = (0, $ia05w.getPackageInfo)(event, (0, $6dMJ8.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $ia05w.getPackageInfo)(event, (0, $6dMJ8.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $2137422a7f16ea46$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($2137422a7f16ea46$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("hvSkz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("4GEic")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("3Oaez")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("gpNMq")).default);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("f86rB")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("f86rB")).withFlagsProvider);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("f86rB")).FlagsProvider);

var $4GEic = parcelRequire("4GEic");

var $3Oaez = parcelRequire("3Oaez");

var $gpNMq = parcelRequire("gpNMq");

var $f86rB = parcelRequire("f86rB");

});
parcelRegister("4GEic", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5e82f72748a7cd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $9tGLw = parcelRequire("9tGLw");

var $c8Z6K = parcelRequire("c8Z6K");

var $gpNMq = parcelRequire("gpNMq");

var $k23Z4 = parcelRequire("k23Z4");
var $eu4h0 = parcelRequire("eu4h0");
function $db5e82f72748a7cd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db5e82f72748a7cd$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
// For cases where a single word is longer than the container (e.g. filenames)
const $db5e82f72748a7cd$var$overflowWrapStyles = (0, $1ZAYh.xcss)({
    overflowWrap: 'anywhere'
});
const $db5e82f72748a7cd$var$descriptionStyles = {
    name: "1hbzboe",
    styles: "max-height:100px;overflow:auto;overflow-wrap:anywhere"
};
const $db5e82f72748a7cd$var$iconWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'start',
    flexShrink: 0,
    color: `var(${$db5e82f72748a7cd$var$CSS_VAR_ICON_COLOR})`
});
const $db5e82f72748a7cd$var$flagStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius.100',
    overflow: 'hidden',
    zIndex: 'flag',
    width: '100%',
    transition: 'background-color 200ms'
});
const $db5e82f72748a7cd$var$flagWrapperStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $db5e82f72748a7cd$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
const $db5e82f72748a7cd$var$transitionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    flexGrow: 1,
    transition: `gap 0.3s`
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $db5e82f72748a7cd$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $b4cc463b68660864$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $5Q9wj.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $5Q9wj.default), onDismissed: onDismissedProp = (0, $5Q9wj.default), testId: testId, id: id, analyticsContext: analyticsContext } = props;
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gpNMq.useFlagGroup)();
    const onDismissed = (0, $eUqFw.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(false);
    const onDismissedAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$db5e82f72748a7cd$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $b4cc463b68660864$export$d6830277b06edd6);
    const toggleExpand = (0, $eUqFw.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $eUqFw.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    const onFocusAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$db5e82f72748a7cd$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$db5e82f72748a7cd$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $9tGLw.flagTextColor)[appearance];
    const iconColor = (0, $9tGLw.flagIconColor)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "alert",
        css: $db5e82f72748a7cd$var$flagWrapperStyles,
        "data-testid": testId,
        ...autoDismissProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        backgroundColor: (0, $9tGLw.flagBackgroundColor)[appearance],
        padding: "space.200",
        xcss: $db5e82f72748a7cd$var$flagStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        alignBlock: "stretch",
        space: "space.200"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $db5e82f72748a7cd$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            [$db5e82f72748a7cd$var$CSS_VAR_ICON_COLOR]: iconColor
        }
    }, icon), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $db5e82f72748a7cd$var$transitionStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingBlockStart: "space.025",
        xcss: $db5e82f72748a7cd$var$overflowWrapStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        color: textColor,
        weight: "semibold"
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $byn9U.jsx)((0, $k23Z4.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eu4h0.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $9tGLw.flagTextColorToken)[appearance]
        },
        css: $db5e82f72748a7cd$var$descriptionStyles,
        "data-testid": testId && `${testId}-description`
    }, description), /*#__PURE__*/ (0, $byn9U.jsx)((0, $c8Z6K.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $db5e82f72748a7cd$export$2e2bcd8739ae039 = $db5e82f72748a7cd$var$Flag;

});
parcelRegister("b5IAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $488a65ffb88553e7$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");

var $1ZAYh = parcelRequire("1ZAYh");

var $5Yal2 = parcelRequire("5Yal2");
function $488a65ffb88553e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $488a65ffb88553e7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-expect-error Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $488a65ffb88553e7$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9seLS.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9seLS.isSurfaceColorToken)(backgroundColor) && (0, $9seLS.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $9seLS.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $9seLS.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $9seLS.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $9seLS.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $9seLS.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $9seLS.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $9seLS.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Yal2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $488a65ffb88553e7$export$2e2bcd8739ae039 = $488a65ffb88553e7$export$e71c4d32a2263218;
const $488a65ffb88553e7$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("9seLS", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $73ee395a6b21c4f5$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $73ee395a6b21c4f5$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $73ee395a6b21c4f5$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $73ee395a6b21c4f5$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $73ee395a6b21c4f5$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $73ee395a6b21c4f5$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $73ee395a6b21c4f5$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $73ee395a6b21c4f5$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $73ee395a6b21c4f5$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $73ee395a6b21c4f5$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $73ee395a6b21c4f5$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $73ee395a6b21c4f5$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $73ee395a6b21c4f5$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $73ee395a6b21c4f5$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $73ee395a6b21c4f5$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $73ee395a6b21c4f5$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $73ee395a6b21c4f5$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "fontStylesMap", () => $73ee395a6b21c4f5$export$128f10c238242f83);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $73ee395a6b21c4f5$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $73ee395a6b21c4f5$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $kyri3 = parcelRequire("kyri3");
const $73ee395a6b21c4f5$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $73ee395a6b21c4f5$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $73ee395a6b21c4f5$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $73ee395a6b21c4f5$export$632685d741f3dbbf = {
    ...$73ee395a6b21c4f5$export$958d0ae7f2977ae4,
    ...$73ee395a6b21c4f5$export$d2dc61f58390201c
};
const $73ee395a6b21c4f5$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $73ee395a6b21c4f5$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $73ee395a6b21c4f5$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $73ee395a6b21c4f5$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $73ee395a6b21c4f5$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $73ee395a6b21c4f5$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $73ee395a6b21c4f5$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $73ee395a6b21c4f5$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $73ee395a6b21c4f5$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $73ee395a6b21c4f5$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $73ee395a6b21c4f5$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $73ee395a6b21c4f5$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $73ee395a6b21c4f5$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $73ee395a6b21c4f5$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $73ee395a6b21c4f5$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $73ee395a6b21c4f5$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $73ee395a6b21c4f5$export$e615f061ca585a6c = $73ee395a6b21c4f5$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $73ee395a6b21c4f5$var$getSerializedStylesMap(spacingProperty, $73ee395a6b21c4f5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $73ee395a6b21c4f5$export$bf46c3f9eeafc71f = $73ee395a6b21c4f5$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $73ee395a6b21c4f5$var$getSerializedStylesMap(spacingProperty, $73ee395a6b21c4f5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $73ee395a6b21c4f5$export$e7af83bafe7f9e63 = $73ee395a6b21c4f5$var$getSerializedStylesMap('backgroundColor', $73ee395a6b21c4f5$export$d1d79bf68ac056bd);
const $73ee395a6b21c4f5$export$3a1bcba60b23d7f0 = $73ee395a6b21c4f5$var$getSerializedStylesMap('color', $73ee395a6b21c4f5$export$8473307aa00d6ea1);
const $73ee395a6b21c4f5$export$45f3f4fe16f9f7d5 = $73ee395a6b21c4f5$var$getSerializedStylesMap('fontWeight', $73ee395a6b21c4f5$export$303e322c6b1ed114);
const $73ee395a6b21c4f5$export$68cc305da27dbaa4 = $73ee395a6b21c4f5$var$getSerializedStylesMap('fontFamily', $73ee395a6b21c4f5$export$3c7e9587132614b4);
const $73ee395a6b21c4f5$export$128f10c238242f83 = $73ee395a6b21c4f5$var$getSerializedStylesMap('font', $73ee395a6b21c4f5$export$6cc560b4dedf3816);
const $73ee395a6b21c4f5$export$ff257d957d48c421 = $73ee395a6b21c4f5$var$getSerializedStylesMap((0, $kyri3.CURRENT_SURFACE_CSS_VAR), $73ee395a6b21c4f5$export$41a358c9c2356760);
const $73ee395a6b21c4f5$export$5e65a44e5b6ecadb = (color)=>$73ee395a6b21c4f5$export$41a358c9c2356760[color] !== undefined;

});
parcelRegister("kyri3", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $491dfb80863601f9$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $491dfb80863601f9$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $491dfb80863601f9$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $491dfb80863601f9$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $491dfb80863601f9$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $491dfb80863601f9$export$9d7b58831ae93caa);
const $491dfb80863601f9$export$4ef52930e33717cd = 'data-theme';
const $491dfb80863601f9$export$a00eac3f8684bcd0 = 'data-color-mode';
const $491dfb80863601f9$export$2112803007239c61 = 'data-contrast-mode';
const $491dfb80863601f9$export$352e418ed5b6193a = 'data-custom-theme';
const $491dfb80863601f9$export$2faeed762aac6741 = 'light';
const $491dfb80863601f9$export$6f0c6fb8c80fcc92 = 'ds';
const $491dfb80863601f9$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $491dfb80863601f9$export$dddac1532e822863 = `--${$491dfb80863601f9$export$6f0c6fb8c80fcc92}-token-not-found`;
const $491dfb80863601f9$export$9d7b58831ae93caa = `--${$491dfb80863601f9$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("1ZAYh", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $7ee483e738ecf878$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $7ee483e738ecf878$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");

var $2fFJv = parcelRequire("2fFJv");
const $7ee483e738ecf878$export$9a199fbafee0014e = {
    backgroundColor: (0, $9seLS.backgroundColorMap),
    blockSize: (0, $9seLS.dimensionMap),
    borderBlockColor: (0, $9seLS.borderColorMap),
    borderBlockEndColor: (0, $9seLS.borderColorMap),
    borderBlockEndWidth: (0, $9seLS.borderWidthMap),
    borderBlockStartColor: (0, $9seLS.borderColorMap),
    borderBlockStartWidth: (0, $9seLS.borderWidthMap),
    borderBlockWidth: (0, $9seLS.borderWidthMap),
    borderBottomColor: (0, $9seLS.borderColorMap),
    borderBottomLeftRadius: (0, $9seLS.borderRadiusMap),
    borderBottomRightRadius: (0, $9seLS.borderRadiusMap),
    borderBottomWidth: (0, $9seLS.borderWidthMap),
    borderColor: (0, $9seLS.borderColorMap),
    borderEndEndRadius: (0, $9seLS.borderRadiusMap),
    borderEndStartRadius: (0, $9seLS.borderRadiusMap),
    borderInlineColor: (0, $9seLS.borderColorMap),
    borderInlineEndColor: (0, $9seLS.borderColorMap),
    borderInlineEndWidth: (0, $9seLS.borderWidthMap),
    borderInlineStartColor: (0, $9seLS.borderColorMap),
    borderInlineStartWidth: (0, $9seLS.borderWidthMap),
    borderInlineWidth: (0, $9seLS.borderWidthMap),
    borderLeftColor: (0, $9seLS.borderColorMap),
    borderLeftWidth: (0, $9seLS.borderWidthMap),
    borderRadius: (0, $9seLS.borderRadiusMap),
    borderRightColor: (0, $9seLS.borderColorMap),
    borderRightWidth: (0, $9seLS.borderWidthMap),
    borderStartEndRadius: (0, $9seLS.borderRadiusMap),
    borderStartStartRadius: (0, $9seLS.borderRadiusMap),
    borderTopColor: (0, $9seLS.borderColorMap),
    borderTopLeftRadius: (0, $9seLS.borderRadiusMap),
    borderTopRightRadius: (0, $9seLS.borderRadiusMap),
    borderTopWidth: (0, $9seLS.borderWidthMap),
    borderWidth: (0, $9seLS.borderWidthMap),
    bottom: (0, $9seLS.allSpaceMap),
    boxShadow: (0, $9seLS.shadowMap),
    color: (0, $9seLS.textColorMap),
    columnGap: (0, $9seLS.positiveSpaceMap),
    gap: (0, $9seLS.positiveSpaceMap),
    height: (0, $9seLS.dimensionMap),
    inlineSize: (0, $9seLS.dimensionMap),
    inset: (0, $9seLS.allSpaceMap),
    insetBlock: (0, $9seLS.allSpaceMap),
    insetBlockEnd: (0, $9seLS.allSpaceMap),
    insetBlockStart: (0, $9seLS.allSpaceMap),
    insetInline: (0, $9seLS.allSpaceMap),
    insetInlineEnd: (0, $9seLS.allSpaceMap),
    insetInlineStart: (0, $9seLS.allSpaceMap),
    left: (0, $9seLS.allSpaceMap),
    margin: (0, $9seLS.allSpaceMap),
    marginBlock: (0, $9seLS.allSpaceMap),
    marginBlockEnd: (0, $9seLS.allSpaceMap),
    marginBlockStart: (0, $9seLS.allSpaceMap),
    marginBottom: (0, $9seLS.allSpaceMap),
    marginInline: (0, $9seLS.allSpaceMap),
    marginInlineEnd: (0, $9seLS.allSpaceMap),
    marginInlineStart: (0, $9seLS.allSpaceMap),
    marginLeft: (0, $9seLS.allSpaceMap),
    marginRight: (0, $9seLS.allSpaceMap),
    marginTop: (0, $9seLS.allSpaceMap),
    maxBlockSize: (0, $9seLS.dimensionMap),
    maxHeight: (0, $9seLS.dimensionMap),
    maxInlineSize: (0, $9seLS.dimensionMap),
    maxWidth: (0, $9seLS.dimensionMap),
    minBlockSize: (0, $9seLS.dimensionMap),
    minHeight: (0, $9seLS.dimensionMap),
    minInlineSize: (0, $9seLS.dimensionMap),
    minWidth: (0, $9seLS.dimensionMap),
    opacity: (0, $9seLS.opacityMap),
    outlineColor: (0, $9seLS.borderColorMap),
    outlineOffset: (0, $9seLS.positiveSpaceMap),
    outlineWidth: (0, $9seLS.borderWidthMap),
    padding: (0, $9seLS.positiveSpaceMap),
    paddingBlock: (0, $9seLS.positiveSpaceMap),
    paddingBlockEnd: (0, $9seLS.positiveSpaceMap),
    paddingBlockStart: (0, $9seLS.positiveSpaceMap),
    paddingBottom: (0, $9seLS.positiveSpaceMap),
    paddingInline: (0, $9seLS.positiveSpaceMap),
    paddingInlineEnd: (0, $9seLS.positiveSpaceMap),
    paddingInlineStart: (0, $9seLS.positiveSpaceMap),
    paddingLeft: (0, $9seLS.positiveSpaceMap),
    paddingRight: (0, $9seLS.positiveSpaceMap),
    paddingTop: (0, $9seLS.positiveSpaceMap),
    right: (0, $9seLS.allSpaceMap),
    rowGap: (0, $9seLS.positiveSpaceMap),
    top: (0, $9seLS.allSpaceMap),
    width: (0, $9seLS.dimensionMap),
    zIndex: (0, $9seLS.layerMap)
};
const $7ee483e738ecf878$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $7ee483e738ecf878$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $7ee483e738ecf878$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $7ee483e738ecf878$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $7ee483e738ecf878$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($7ee483e738ecf878$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $7ee483e738ecf878$var$safeSelectors.test(key)) {
            styleObj[key] = $7ee483e738ecf878$var$transformStyles(value);
            return;
        }
        if ($7ee483e738ecf878$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7ee483e738ecf878$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7ee483e738ecf878$export$9a199fbafee0014e)) return;
        const tokenValue = $7ee483e738ecf878$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $7ee483e738ecf878$var$baseXcss = (style)=>{
    const transformedStyles = $7ee483e738ecf878$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$7ee483e738ecf878$var$uniqueSymbol]: /*#__PURE__*/ (0, $byn9U.css)(transformedStyles)
    };
};
const $7ee483e738ecf878$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $7ee483e738ecf878$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$7ee483e738ecf878$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7ee483e738ecf878$export$f6c783d06584602c(style) {
    return $7ee483e738ecf878$var$baseXcss(style);
}

});

parcelRegister("5Yal2", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $534a0cdc9f93769c$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $534a0cdc9f93769c$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $534a0cdc9f93769c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $534a0cdc9f93769c$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($534a0cdc9f93769c$export$1ca2a26fecb070ae);
};
$534a0cdc9f93769c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("9Amv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ce3e667fcbb9b4$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $c0jFd = parcelRequire("c0jFd");
const $64ce3e667fcbb9b4$var$flexGrowMap = {
    hug: (0, $1ZAYh.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1ZAYh.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $64ce3e667fcbb9b4$var$separatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $64ce3e667fcbb9b4$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $64ce3e667fcbb9b4$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $64ce3e667fcbb9b4$var$Inline = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $byn9U.jsx)($64ce3e667fcbb9b4$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $eUqFw.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $64ce3e667fcbb9b4$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$64ce3e667fcbb9b4$var$Inline.displayName = 'Inline';
var $64ce3e667fcbb9b4$export$2e2bcd8739ae039 = $64ce3e667fcbb9b4$var$Inline;

});
parcelRegister("c0jFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d0d156564f593bd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");

var $1ZAYh = parcelRequire("1ZAYh");
function $8d0d156564f593bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d0d156564f593bd$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $8d0d156564f593bd$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $8d0d156564f593bd$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $8d0d156564f593bd$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $8d0d156564f593bd$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $8d0d156564f593bd$var$Flex = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $8d0d156564f593bd$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9seLS.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9seLS.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9seLS.spaceStylesMap).rowGap[rowGap],
            alignItems && $8d0d156564f593bd$var$alignItemsMap[alignItems],
            direction && $8d0d156564f593bd$var$flexDirectionMap[direction],
            justifyContent && $8d0d156564f593bd$var$justifyContentMap[justifyContent],
            wrap && $8d0d156564f593bd$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$8d0d156564f593bd$var$Flex.displayName = 'Flex';
var $8d0d156564f593bd$export$2e2bcd8739ae039 = $8d0d156564f593bd$var$Flex;

});


parcelRegister("1zbEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ddd810ea9dbc8f4$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $c0jFd = parcelRequire("c0jFd");
const $0ddd810ea9dbc8f4$var$flexGrowMap = {
    hug: (0, $1ZAYh.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1ZAYh.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $0ddd810ea9dbc8f4$var$Stack = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $0ddd810ea9dbc8f4$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c0jFd.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0ddd810ea9dbc8f4$var$Stack.displayName = 'Stack';
var $0ddd810ea9dbc8f4$export$2e2bcd8739ae039 = $0ddd810ea9dbc8f4$var$Stack;

});

parcelRegister("1Yimi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3478fcd99de93e8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ynlC = parcelRequire("8ynlC");

var $9seLS = parcelRequire("9seLS");

var $5Yal2 = parcelRequire("5Yal2");
function $e3478fcd99de93e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3478fcd99de93e8$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $e3478fcd99de93e8$var$resetStyles = {
    name: "ti75j2",
    styles: "margin:0"
};
const $e3478fcd99de93e8$var$strongStyles = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
const $e3478fcd99de93e8$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $e3478fcd99de93e8$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $e3478fcd99de93e8$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $e3478fcd99de93e8$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
const $e3478fcd99de93e8$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $e3478fcd99de93e8$var$useHasTextAncestor = ()=>(0, $eUqFw.useContext)($e3478fcd99de93e8$var$HasTextAncestorContext);
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $e3478fcd99de93e8$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5Yal2.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $9seLS.inverseColorMap).hasOwnProperty(surface)) return (0, $9seLS.inverseColorMap)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $e3478fcd99de93e8$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size = 'medium', weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $8ynlC.default)($e3478fcd99de93e8$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = $e3478fcd99de93e8$var$useHasTextAncestor();
    const color = $e3478fcd99de93e8$var$useColor(colorProp, hasTextAncestor);
    const component = /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        ref: ref,
        css: [
            $e3478fcd99de93e8$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9seLS.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $9seLS.textColorStylesMap)[color],
            maxLines && $e3478fcd99de93e8$var$truncationStyles,
            maxLines === 1 && $e3478fcd99de93e8$var$wordBreakMap.breakAll,
            align && $e3478fcd99de93e8$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $9seLS.fontWeightStylesMap)[weight],
            Component === 'em' && $e3478fcd99de93e8$var$emStyles,
            Component === 'strong' && $e3478fcd99de93e8$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $byn9U.jsx)($e3478fcd99de93e8$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $e3478fcd99de93e8$export$2e2bcd8739ae039 = $e3478fcd99de93e8$var$Text;

});

const $b4cc463b68660864$export$d6830277b06edd6 = 'normal';
const $b4cc463b68660864$export$4f8f13a66ae77bdd = '--color';
const $b4cc463b68660864$export$e9244ec13bd422b5 = '--bg-color';
const $b4cc463b68660864$export$97e78d9745006c11 = '--bg-color-hover';
const $b4cc463b68660864$export$291d63757828f290 = '--bg-color-active';

parcelRegister("9tGLw", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", () => $a5e47a6e35d67a59$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $a5e47a6e35d67a59$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagTextColor", () => $a5e47a6e35d67a59$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $a5e47a6e35d67a59$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $a5e47a6e35d67a59$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $a5e47a6e35d67a59$export$7bcfe3cca4dd78b6);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");
const $a5e47a6e35d67a59$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $a5e47a6e35d67a59$export$7f70afe2167f8235 = {
    error: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    info: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    normal: `var(--ds-icon-subtle, ${(0, $PdmhA.N500)})`,
    success: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    warning: `var(--ds-icon-warning-inverse, ${(0, $PdmhA.N700)})`
};
const $a5e47a6e35d67a59$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text.subtle',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $a5e47a6e35d67a59$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    normal: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    success: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $PdmhA.N700)})`
};
const $a5e47a6e35d67a59$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $PdmhA.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $PdmhA.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $PdmhA.N30A)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $PdmhA.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $PdmhA.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $PdmhA.N30A)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $PdmhA.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $PdmhA.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $PdmhA.N30A)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $PdmhA.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $PdmhA.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $PdmhA.N30A)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $a5e47a6e35d67a59$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    error: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $PdmhA.N700)})`,
    normal: `var(--ds-link, ${(0, $PdmhA.B400)})`
};

});

parcelRegister("c8Z6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88b5c75aa1d81bf$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $9Amv1 = parcelRequire("9Amv1");


var $9tGLw = parcelRequire("9tGLw");
function $c88b5c75aa1d81bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c88b5c75aa1d81bf$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&, a&&': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: `0 ${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: `var(${(0, $b4cc463b68660864$export$e9244ec13bd422b5)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $b4cc463b68660864$export$4f8f13a66ae77bdd)}) !important`,
        fontWeight: "var(--ds-font-weight-medium, 500)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:hover, &&:active, a&&:hover, a&&:active': {
        textDecoration: 'underline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $b4cc463b68660864$export$97e78d9745006c11)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $b4cc463b68660864$export$291d63757828f290)})`
    }
});
const $c88b5c75aa1d81bf$var$appearanceNormalButtonStyles = {
    name: "e4wh89",
    styles: "&&, a&&{padding:0 !important;}"
};
const $c88b5c75aa1d81bf$var$appearanceNormalActionsContainerStyles = {
    name: "m2h6lc",
    styles: "&&, a&&{transform:translateX(-2px);}"
};
const $c88b5c75aa1d81bf$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $b4cc463b68660864$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $b4cc463b68660864$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: !isBold && $c88b5c75aa1d81bf$var$appearanceNormalActionsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && `${testId}-actions`
    }, actions.map((action, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [(0, $b4cc463b68660864$export$4f8f13a66ae77bdd)]: (0, $9tGLw.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [(0, $b4cc463b68660864$export$e9244ec13bd422b5)]: (0, $9tGLw.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [(0, $b4cc463b68660864$export$97e78d9745006c11)]: (0, $9tGLw.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [(0, $b4cc463b68660864$export$291d63757828f290)]: (0, $9tGLw.actionBackgroundColor)[appearance].active
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                $c88b5c75aa1d81bf$var$buttonStyles,
                appearance === (0, $b4cc463b68660864$export$d6830277b06edd6) && $c88b5c75aa1d81bf$var$appearanceNormalButtonStyles
            ]
        }, action.content))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c88b5c75aa1d81bf$export$2e2bcd8739ae039 = $c88b5c75aa1d81bf$var$FlagActions;

});

parcelRegister("gpNMq", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", () => $0053ea9b093e8cce$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $0053ea9b093e8cce$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lSV8Z = parcelRequire("lSV8Z");
var $2EVgw = parcelRequire("2EVgw");

var $lkPEe = parcelRequire("lkPEe");

var $5Q9wj = parcelRequire("5Q9wj");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");
function $0053ea9b093e8cce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0053ea9b093e8cce$var$gridSize = (0, $lcnyw.gridSize)();
const $0053ea9b093e8cce$export$1eee5ddc4f6d41c5 = $0053ea9b093e8cce$var$gridSize * 50;
const $0053ea9b093e8cce$export$a56455a41666bb2a = 400;
const $0053ea9b093e8cce$var$defaultFlagGroupContext = {
    onDismissed: (0, $5Q9wj.default),
    isDismissAllowed: false
};
const $0053ea9b093e8cce$export$c57ba665aaa722be = /*#__PURE__*/ (0, $eUqFw.createContext)($0053ea9b093e8cce$var$defaultFlagGroupContext);
function $0053ea9b093e8cce$export$e91ea202abb66350() {
    return (0, $eUqFw.useContext)($0053ea9b093e8cce$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $0053ea9b093e8cce$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $0053ea9b093e8cce$export$1eee5ddc4f6d41c5,
    position: 'absolute',
    insetBlockEnd: 0,
    transition: `transform ${$0053ea9b093e8cce$export$a56455a41666bb2a}ms ease-in-out`,
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '@media (max-width: 560px)': {
        width: '100vw'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        transform: `translate(0,0)`,
        transition: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':nth-of-type(n + 2)': {
        animationDuration: '0ms',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `translateX(0) translateY(100%) translateY(${2 * $0053ea9b093e8cce$var$gridSize}px)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':nth-of-type(1)': {
        zIndex: 5
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':nth-of-type(2)': {
        zIndex: 4
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:nth-of-type(n + 4)': {
        visibility: 'hidden'
    }
});
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $0053ea9b093e8cce$var$dismissAllowedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& + *': {
        transform: `translate(0, 0)`,
        transitionDuration: `${$0053ea9b093e8cce$export$a56455a41666bb2a / 2}ms`
    }
});
const $0053ea9b093e8cce$var$flagGroupContainerStyles = {
    name: "1xdxiey",
    styles: "position:fixed;z-index:flag;inset-block-end:var(--ds-space-600, 48px);inset-inline-start:var(--ds-space-1000, 80px);@media (max-width: 560px){inset-block-end:0;inset-inline-start:0;}"
};
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $0053ea9b093e8cce$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $5Q9wj.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $eUqFw.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $eUqFw.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EVgw.default), {
                enterFrom: "left",
                fade: "inout",
                duration: $0053ea9b093e8cce$export$a56455a41666bb2a,
                animationTimingFunction: ()=>(0, $d58b680a02f4d6a4$export$929e5a82286172a6)
            }, ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: [
                        $0053ea9b093e8cce$var$baseStyles,
                        isDismissAllowed && $0053ea9b093e8cce$var$dismissAllowedStyles
                    ],
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: className,
                    ref: ref
                }, /*#__PURE__*/ (0, $byn9U.jsx)($0053ea9b093e8cce$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $0053ea9b093e8cce$var$defaultFlagGroupContext
                }, flag)));
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        id: id,
        css: $0053ea9b093e8cce$var$flagGroupContainerStyles
    }, hasFlags ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)(LabelTag, null, label)) : null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $byn9U.jsx)((0, $gmZvv.default), {
        zIndex: (0, $lcnyw.layers).flag()
    }, flags);
};
var $0053ea9b093e8cce$export$2e2bcd8739ae039 = $0053ea9b093e8cce$var$FlagGroup;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("lSV8Z", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $bb1510dabf307506$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $bb1510dabf307506$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $jq3Aw = parcelRequire("jq3Aw");
// We define empty context here so the object doesn't change.
const $bb1510dabf307506$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
const $bb1510dabf307506$var$ExitingContext = /*#__PURE__*/ (0, $eUqFw.createContext)($bb1510dabf307506$var$emptyContext);
const $bb1510dabf307506$var$isAnyPreviousKeysMissingFromCurrent = (currentMap, previous)=>{
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMap[key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $bb1510dabf307506$var$wrapChildWithContextProvider = (child, value = $bb1510dabf307506$var$emptyContext)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb1510dabf307506$var$ExitingContext.Provider, {
        key: `${child.key}-provider`,
        value: value
    }, child);
};
const $bb1510dabf307506$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $bb1510dabf307506$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $bb1510dabf307506$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $bb1510dabf307506$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $eUqFw.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ const $bb1510dabf307506$var$hasAnyExitingChildMountedAgain = (exitingChildren, children)=>{
    let exitingChildMountedAgain = false;
    children.forEach((child)=>{
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $bb1510dabf307506$var$ExitingPersistence = /*#__PURE__*/ (0, $eUqFw.memo)(({ appear: appearFromProp = false, children: childs, exitThenEnter: exitThenEnter })=>{
    const children = $bb1510dabf307506$var$childrenToArray(childs);
    const childrenObj = $bb1510dabf307506$var$childrenToObj(children);
    const previousChildren = (0, $eUqFw.useRef)([]);
    const persistedChildren = (0, $eUqFw.useRef)([]);
    const forceRender = (0, $jq3Aw.useForceRender)();
    const exitingChildren = (0, $eUqFw.useRef)({});
    const appear = (0, $eUqFw.useRef)(appearFromProp);
    const defaultContextValue = (0, $eUqFw.useMemo)(()=>({
            appear: appear.current,
            isExiting: false
        }), // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $8YJjX.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $bb1510dabf307506$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $bb1510dabf307506$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $bb1510dabf307506$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map((child)=>{
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $bb1510dabf307506$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: ()=>{
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $bb1510dabf307506$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map((child)=>$bb1510dabf307506$var$wrapChildWithContextProvider(child, defaultContextValue));
});
const $bb1510dabf307506$export$3b6f38abbdcbd000 = ()=>{
    return (0, $eUqFw.useContext)($bb1510dabf307506$var$ExitingContext);
};
$bb1510dabf307506$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $bb1510dabf307506$export$2e2bcd8739ae039 = $bb1510dabf307506$var$ExitingPersistence;

});
parcelRegister("8YJjX", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $eb46033ebabb2575$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $eb46033ebabb2575$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $eb46033ebabb2575$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $eb46033ebabb2575$export$ff7706047246b98b);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
const $eb46033ebabb2575$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $eb46033ebabb2575$export$b7baf7667a68d87c = ()=>{
    if (!$eb46033ebabb2575$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $eb46033ebabb2575$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $eUqFw.useState)($eb46033ebabb2575$export$b7baf7667a68d87c);
    (0, $eUqFw.useEffect)(()=>{
        if (!$eb46033ebabb2575$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $74BVL.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $eb46033ebabb2575$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $eb46033ebabb2575$export$ff7706047246b98b = ()=>$eb46033ebabb2575$export$f0f789643ba5a83c;

});

parcelRegister("jq3Aw", function(module, exports) {

$parcel$export(module.exports, "useForceRender", () => $2897daacdecdb683$export$b902f6ef73d6633a);

var $eUqFw = parcelRequire("eUqFw");
const $2897daacdecdb683$export$b902f6ef73d6633a = ()=>{
    const [, updateState] = (0, $eUqFw.useState)({});
    const forceRender = (0, $eUqFw.useCallback)(()=>updateState({}), []);
    return forceRender;
};

});


parcelRegister("2EVgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b9e35294b750a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $5LHuc = parcelRequire("5LHuc");

var $kCN6h = parcelRequire("kCN6h");
const $00b9e35294b750a3$export$97192c8fa0d5e26b = (from, state, fade)=>{
    const initial = state === 'entering' ? '0%' : '100%';
    const end = state === 'entering' ? '100%' : '0%';
    const fromMap = {
        top: 'translate3d(0, -100%, 0)',
        right: 'translate3d(100%, 0, 0)',
        bottom: 'translate3d(0, 100%, 0)',
        left: 'translate3d(-100%, 0, 0)'
    };
    const animateOpacity = fade === 'inout' || fade === 'in' && state === 'entering' || fade === 'out' && state === 'exiting';
    return {
        [initial]: {
            transform: fromMap[from],
            opacity: animateOpacity ? 0 : 1
        },
        [end]: {
            transform: 'none',
            opacity: 1
        }
    };
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $00b9e35294b750a3$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, fade: fade = 'none', duration: duration = (0, $5LHuc.mediumDurationMs), isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = (state)=>state === 'entering' ? (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0) : (0, $d58b680a02f4d6a4$export$929e5a82286172a6) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCN6h.default), {
        duration: duration,
        enteringAnimation: $00b9e35294b750a3$export$97192c8fa0d5e26b(enterFrom, 'entering', fade),
        exitingAnimation: $00b9e35294b750a3$export$97192c8fa0d5e26b(exitTo || enterFrom, 'exiting', fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $00b9e35294b750a3$export$2e2bcd8739ae039 = $00b9e35294b750a3$var$SlideIn;

});
parcelRegister("5LHuc", function(module, exports) {

$parcel$export(module.exports, "smallDurationMs", () => $91aa4216bc43aed4$export$2023a81c8547415f);
$parcel$export(module.exports, "mediumDurationMs", () => $91aa4216bc43aed4$export$6fa259be09e118a7);
$parcel$export(module.exports, "largeDurationMs", () => $91aa4216bc43aed4$export$9424640c29bc466d);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $91aa4216bc43aed4$export$368bacef0dacbe05 = 25;
const $91aa4216bc43aed4$export$2023a81c8547415f = $91aa4216bc43aed4$export$368bacef0dacbe05 * 4;
const $91aa4216bc43aed4$export$6fa259be09e118a7 = $91aa4216bc43aed4$export$368bacef0dacbe05 * 14;
const $91aa4216bc43aed4$export$9424640c29bc466d = $91aa4216bc43aed4$export$368bacef0dacbe05 * 28;

});

parcelRegister("kCN6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6c3e6feb312587$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $5LHuc = parcelRequire("5LHuc");

var $5bTtn = parcelRequire("5bTtn");

var $lSV8Z = parcelRequire("lSV8Z");

var $gYTpN = parcelRequire("gYTpN");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $0d6c3e6feb312587$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $0d6c3e6feb312587$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = (0, $5LHuc.largeDurationMs) })=>{
    const staggered = (0, $gYTpN.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $lSV8Z.useExitingPersistence)();
    const setTimeout = (0, $5bTtn.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $eUqFw.useState)(appear);
    (0, $eUqFw.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(()=>{
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $0d6c3e6feb312587$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css({
                ...(0, $8YJjX.reduceMotionAsPerUserPreference),
                animationDelay: `${delay}ms`,
                animationDuration: `${isExiting ? duration * $0d6c3e6feb312587$var$EXITING_MOTION_MULTIPLIER : duration}ms`,
                animationFillMode: isExiting ? 'forwards' : 'backwards',
                animationName: `${(0, $byn9U.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)}`,
                animationPlayState: paused ? 'paused' : 'running',
                animationTimingFunction: animationTimingFunction(state)
            }) : ''
        }, state));
};
var $0d6c3e6feb312587$export$2e2bcd8739ae039 = $0d6c3e6feb312587$var$EnteringMotion;

});
parcelRegister("5bTtn", function(module, exports) {

$parcel$export(module.exports, "useRequestAnimationFrame", () => $eb0f3eaee8720dce$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $eb0f3eaee8720dce$export$4f34107a2b00f39c);

var $eUqFw = parcelRequire("eUqFw");
const $eb0f3eaee8720dce$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $eb0f3eaee8720dce$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $eUqFw.useRef)([]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $eb0f3eaee8720dce$var$getHookDeps(opts));
    return (0, $eUqFw.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $eb0f3eaee8720dce$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $eUqFw.useRef)([]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $eb0f3eaee8720dce$var$getHookDeps(opts));
    return (0, $eUqFw.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("gYTpN", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $2c067b1398c90a06$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $2c067b1398c90a06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $3WV8S = parcelRequire("3WV8S");

var $bFabu = parcelRequire("bFabu");
const $2c067b1398c90a06$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $eUqFw.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $5Q9wj.default)
    }));
const $2c067b1398c90a06$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $bFabu.useUniqueId)();
    const context = (0, $eUqFw.useContext)($2c067b1398c90a06$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $2c067b1398c90a06$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $eUqFw.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $eUqFw.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $3WV8S.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c067b1398c90a06$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        }
    }, children);
};
var $2c067b1398c90a06$export$2e2bcd8739ae039 = $2c067b1398c90a06$var$StaggeredEntrance;

});
parcelRegister("3WV8S", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $20320ba4962119c0$export$e5c5a5f917a5871c);

var $eUqFw = parcelRequire("eUqFw");
const $20320ba4962119c0$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $eUqFw.useEffect) : (0, $eUqFw.useLayoutEffect);

});

parcelRegister("bFabu", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $681852313fb852d2$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $eUqFw = parcelRequire("eUqFw");
function $681852313fb852d2$export$c485849f2e393253() {
    const identifier = (0, $eUqFw.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("gmZvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec999bdcfe7e1efd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2aYvD = parcelRequire("2aYvD");

var $73PhI = parcelRequire("73PhI");

var $adpJl = parcelRequire("adpJl");
function $ec999bdcfe7e1efd$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $73PhI.default)(mountStrategy);
    (0, $adpJl.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aYvD.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("2aYvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa9b3c7d3abf8dda$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $bYlG8 = parcelRequire("bYlG8");
function $aa9b3c7d3abf8dda$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $eUqFw.useMemo)(()=>(0, $bYlG8.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $bYlG8.appendPortalContainerIfNotAppended)(container);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            (0, $bYlG8.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(children, container);
}

});
parcelRegister("bYlG8", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $65317faa100b8622$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $65317faa100b8622$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $65317faa100b8622$export$c582005add11e141);

const $65317faa100b8622$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $deed61a8dba991fd$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $65317faa100b8622$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $65317faa100b8622$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $deed61a8dba991fd$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $deed61a8dba991fd$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $65317faa100b8622$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $65317faa100b8622$export$da99f98bf3fe55b3 = (container)=>{
    $65317faa100b8622$var$getPortalParent().removeChild(container);
};
const $65317faa100b8622$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $65317faa100b8622$var$getPortalParent().appendChild(container);
};

});
const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';



parcelRegister("73PhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d93e30bd64e99c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $blzV2 = parcelRequire("blzV2");
const $69d93e30bd64e99c$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $eUqFw.useState)(false);
    const [useMountEffect] = (0, $eUqFw.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $blzV2.useIsomorphicLayoutEffect) : (0, $eUqFw.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $69d93e30bd64e99c$export$2e2bcd8739ae039 = $69d93e30bd64e99c$var$useIsSubsequentRender;

});
parcelRegister("blzV2", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $0338544f4205db41$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
const $0338544f4205db41$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("adpJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8304a67f76b6cdf8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $lTer5 = parcelRequire("lTer5");
const $8304a67f76b6cdf8$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $eUqFw.useEffect)(()=>{
        (0, $lTer5.default)((0, $7f8b23c982f78b1d$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $lTer5.default)((0, $7f8b23c982f78b1d$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $8304a67f76b6cdf8$export$2e2bcd8739ae039 = $8304a67f76b6cdf8$var$useFirePortalEvent;

});
const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("lTer5", function(module, exports) {

$parcel$export(module.exports, "default", () => $079afa12274d9683$export$2e2bcd8739ae039);
const $079afa12274d9683$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $079afa12274d9683$var$getLayerName = (zIndex)=>{
    return $079afa12274d9683$var$zIndexToName.hasOwnProperty(zIndex) ? $079afa12274d9683$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $079afa12274d9683$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $079afa12274d9683$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $079afa12274d9683$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $079afa12274d9683$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});




parcelRegister("k23Z4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c231bf3cb39562c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ajCg0 = parcelRequire("ajCg0");

var $h0grN = parcelRequire("h0grN");

var $jWuk1 = parcelRequire("jWuk1");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $9tGLw = parcelRequire("9tGLw");
const $c231bf3cb39562c2$var$buttonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    width: '24px',
    height: '24px',
    padding: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    background: 'none',
    borderStyle: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
});
const $c231bf3cb39562c2$var$DismissButton = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($h0grN))) : (0, (/*@__PURE__*/$parcel$interopDefault($ajCg0)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: $c231bf3cb39562c2$var$buttonStyles,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonIcon, {
        label: buttonLabel,
        size: size,
        primaryColor: (0, $9tGLw.flagTextColorToken)[appearance]
    }));
};
var $c231bf3cb39562c2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c231bf3cb39562c2$var$DismissButton);

});
parcelRegister("4ZL0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $840031332d43c903$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $jsCXU = parcelRequire("jsCXU");

var $1ZAYh = parcelRequire("1ZAYh");

var $b5IAe = parcelRequire("b5IAe");
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
const $840031332d43c903$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
const $840031332d43c903$var$focusRingStyles = (0, $1ZAYh.xcss)({
    // Focus styles used when :focus-visible isn't supported
    ':focus': $840031332d43c903$var$baseFocusRingStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    ':focus:not(:focus-visible)': {
        outline: 'none'
    },
    ':focus-visible': $840031332d43c903$var$baseFocusRingStyles,
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $840031332d43c903$var$Pressable = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', testId: testId, xcss: xcssStyles, onClick: providedOnClick = (0, $5Q9wj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    let styles = [
        (0, $1ZAYh.xcss)({
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        }),
        $840031332d43c903$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [
        ...styles,
        ...xcssStyles
    ] : [
        ...styles,
        xcssStyles
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ...htmlAttributes,
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        disabled: isDisabled
    }, children);
});
var $840031332d43c903$export$2e2bcd8739ae039 = $840031332d43c903$var$Pressable;

});


parcelRegister("eu4h0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d8028a61c420adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
const $5d8028a61c420adb$var$expanderStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $5d8028a61c420adb$var$containerStyles = (0, $1ZAYh.xcss)({
    transition: `max-height 0.3s`
});
const $5d8028a61c420adb$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5d8028a61c420adb$var$containerStyles,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $5d8028a61c420adb$var$expanderStyles,
            ...props
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, children)))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d8028a61c420adb$export$2e2bcd8739ae039 = $5d8028a61c420adb$var$Expander;

});
parcelRegister("hYDGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $688aa062fadf07e8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $5LHuc = parcelRequire("5LHuc");

var $kCN6h = parcelRequire("kCN6h");
const $688aa062fadf07e8$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
const $688aa062fadf07e8$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $688aa062fadf07e8$export$8497679fcaaeceb = (direction, distance = 'proportional')=>{
    return {
        from: {
            opacity: 0,
            ...direction !== undefined && {
                transform: $688aa062fadf07e8$var$directionMotions[distance][direction]
            }
        },
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
const $688aa062fadf07e8$export$c9190c6659ea755b = (direction, distance = 'proportional')=>({
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: {
            opacity: 0,
            ...direction !== undefined && {
                transform: $688aa062fadf07e8$var$directionMotions[distance][direction]
            }
        }
    });
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $688aa062fadf07e8$var$FadeIn = ({ children: children, duration: duration = (0, $5LHuc.largeDurationMs), entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection && $688aa062fadf07e8$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCN6h.default), {
        duration: duration,
        enteringAnimation: $688aa062fadf07e8$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $688aa062fadf07e8$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: ()=>(0, $d58b680a02f4d6a4$export$c07234257a03d5e9),
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $688aa062fadf07e8$export$2e2bcd8739ae039 = $688aa062fadf07e8$var$FadeIn;

});



parcelRegister("3Oaez", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff97bd73f3a4a065$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $4GEic = parcelRequire("4GEic");

var $gpNMq = parcelRequire("gpNMq");
const $ff97bd73f3a4a065$var$packageName = undefined;
const $ff97bd73f3a4a065$var$packageVersion = undefined;
const $ff97bd73f3a4a065$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $ff97bd73f3a4a065$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $5Q9wj.default) } = props;
    const autoDismissTimer = (0, $eUqFw.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gpNMq.useFlagGroup)();
    const onDismissed = (0, $eUqFw.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $ff97bd73f3a4a065$var$packageName,
        packageVersion: $ff97bd73f3a4a065$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $eUqFw.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $eUqFw.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $eUqFw.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $ff97bd73f3a4a065$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $ff97bd73f3a4a065$export$2e2bcd8739ae039 = $ff97bd73f3a4a065$var$AutoDismissFlag;

});

parcelRegister("f86rB", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $1e7394bdbeccc703$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $1e7394bdbeccc703$export$a4270ab432ac8a58);
$parcel$export(module.exports, "withFlagsProvider", () => $1e7394bdbeccc703$export$7b676815c264eaf3);

var $eUqFw = parcelRequire("eUqFw");

var $3Oaez = parcelRequire("3Oaez");

var $4GEic = parcelRequire("4GEic");

var $gpNMq = parcelRequire("gpNMq");
const $1e7394bdbeccc703$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $1e7394bdbeccc703$export$2879604e6aec4ab() {
    const api = (0, $eUqFw.useContext)($1e7394bdbeccc703$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $1e7394bdbeccc703$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $1e7394bdbeccc703$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $eUqFw.useState)([]);
    const removeFlag = (0, $eUqFw.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $eUqFw.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $1e7394bdbeccc703$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7394bdbeccc703$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpNMq.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? (0, $3Oaez.default) : (0, $4GEic.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagType, {
            ...restProps,
            key: flag.id
        });
    })));
}
const $1e7394bdbeccc703$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e7394bdbeccc703$export$a4270ab432ac8a58, null, fn());

});


parcelRegister("iFhme", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("i6BC8")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("gqhoH")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("8nlzU")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("6frYP")).Reference);

var $gqhoH = parcelRequire("gqhoH");
var $i6BC8 = parcelRequire("i6BC8");

var $8nlzU = parcelRequire("8nlzU");
var $6frYP = parcelRequire("6frYP");

});
parcelRegister("gqhoH", function(module, exports) {

$parcel$export(module.exports, "top", () => $bf4c91d2f412d8f0$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $bf4c91d2f412d8f0$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $bf4c91d2f412d8f0$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $bf4c91d2f412d8f0$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $bf4c91d2f412d8f0$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $bf4c91d2f412d8f0$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $bf4c91d2f412d8f0$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $bf4c91d2f412d8f0$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $bf4c91d2f412d8f0$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $bf4c91d2f412d8f0$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $bf4c91d2f412d8f0$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $bf4c91d2f412d8f0$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $bf4c91d2f412d8f0$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $bf4c91d2f412d8f0$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $bf4c91d2f412d8f0$export$d087d3878fdf71d5);
var $bf4c91d2f412d8f0$export$1e95b668f3b82d = 'top';
var $bf4c91d2f412d8f0$export$40e543e69a8b3fbb = 'bottom';
var $bf4c91d2f412d8f0$export$79ffe56a765070d2 = 'right';
var $bf4c91d2f412d8f0$export$eabcd2c8791e7bf4 = 'left';
var $bf4c91d2f412d8f0$export$dfb5619354ba860 = 'auto';
var $bf4c91d2f412d8f0$export$aec2ce47c367b8c3 = [
    $bf4c91d2f412d8f0$export$1e95b668f3b82d,
    $bf4c91d2f412d8f0$export$40e543e69a8b3fbb,
    $bf4c91d2f412d8f0$export$79ffe56a765070d2,
    $bf4c91d2f412d8f0$export$eabcd2c8791e7bf4
];
var $bf4c91d2f412d8f0$export$b3571188c770cc5a = 'start';
var $bf4c91d2f412d8f0$export$bd5df0f255a350f8 = 'end';
var $bf4c91d2f412d8f0$export$390fd549c5303b4d = 'clippingParents';
var $bf4c91d2f412d8f0$export$d7b7311ec04a3e8f = 'viewport';
var $bf4c91d2f412d8f0$export$ae5ab1c730825774 = 'popper';
var $bf4c91d2f412d8f0$export$ca50aac9f3ba507f = 'reference';
var $bf4c91d2f412d8f0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $bf4c91d2f412d8f0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $bf4c91d2f412d8f0$export$b3571188c770cc5a,
        placement + "-" + $bf4c91d2f412d8f0$export$bd5df0f255a350f8
    ]);
}, []);
var $bf4c91d2f412d8f0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($bf4c91d2f412d8f0$export$aec2ce47c367b8c3, [
    $bf4c91d2f412d8f0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $bf4c91d2f412d8f0$export$b3571188c770cc5a,
        placement + "-" + $bf4c91d2f412d8f0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $bf4c91d2f412d8f0$export$421679a7c3d56e = 'beforeRead';
var $bf4c91d2f412d8f0$export$aafa59e2e03f2942 = 'read';
var $bf4c91d2f412d8f0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $bf4c91d2f412d8f0$export$c65e99957a05207c = 'beforeMain';
var $bf4c91d2f412d8f0$export$f22da7240b7add18 = 'main';
var $bf4c91d2f412d8f0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $bf4c91d2f412d8f0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $bf4c91d2f412d8f0$export$68d8715fc104d294 = 'write';
var $bf4c91d2f412d8f0$export$70a6e5159acce2e6 = 'afterWrite';
var $bf4c91d2f412d8f0$export$d087d3878fdf71d5 = [
    $bf4c91d2f412d8f0$export$421679a7c3d56e,
    $bf4c91d2f412d8f0$export$aafa59e2e03f2942,
    $bf4c91d2f412d8f0$export$6964f6c886723980,
    $bf4c91d2f412d8f0$export$c65e99957a05207c,
    $bf4c91d2f412d8f0$export$f22da7240b7add18,
    $bf4c91d2f412d8f0$export$bab79516f2d662fe,
    $bf4c91d2f412d8f0$export$8d4d2d70e7d46032,
    $bf4c91d2f412d8f0$export$68d8715fc104d294,
    $bf4c91d2f412d8f0$export$70a6e5159acce2e6
];

});

parcelRegister("i6BC8", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $683d6cdcd7cbe40c$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $2z6mk = parcelRequire("2z6mk");

var $gqhoH = parcelRequire("gqhoH");
const $683d6cdcd7cbe40c$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            padding: 5,
            rootBoundary: 'document'
        }
    }
];
function $683d6cdcd7cbe40c$var$defaultChildrenFn() {
    return null;
}
const $683d6cdcd7cbe40c$var$defaultOffset = [
    0,
    8
];
function $683d6cdcd7cbe40c$export$badac9ada3a0bdf9({ children: children = $683d6cdcd7cbe40c$var$defaultChildrenFn, offset: offset = $683d6cdcd7cbe40c$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed' }) {
    const [offsetX, offsetY] = offset;
    // Merge a new offset modifier only if new offset values passed in
    const internalModifiers = (0, $eUqFw.useMemo)(()=>{
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [
            ...$683d6cdcd7cbe40c$var$constantModifiers,
            offsetModifier
        ];
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $eUqFw.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2z6mk.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("2z6mk", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $1de3c86cd837bcbb$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $8nlzU = parcelRequire("8nlzU");

var $8CPnn = parcelRequire("8CPnn");

var $cF0Fs = parcelRequire("cF0Fs");
var $1de3c86cd837bcbb$var$NOOP = function NOOP() {
    return void 0;
};
var $1de3c86cd837bcbb$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $1de3c86cd837bcbb$var$EMPTY_MODIFIERS = [];
function $1de3c86cd837bcbb$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $1de3c86cd837bcbb$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $8nlzU.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $8CPnn.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $cF0Fs.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $1de3c86cd837bcbb$var$NOOP,
            update: update || $1de3c86cd837bcbb$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $8CPnn.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("8nlzU", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $619135acd942485e$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $619135acd942485e$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $619135acd942485e$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $619135acd942485e$export$3dbd3405086fec7b = $eUqFw.createContext();
var $619135acd942485e$export$cbabb21c2529b130 = $eUqFw.createContext();
function $619135acd942485e$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($619135acd942485e$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($619135acd942485e$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("8CPnn", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $6479b98aa0eda8f3$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $6479b98aa0eda8f3$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $6479b98aa0eda8f3$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $6479b98aa0eda8f3$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $6479b98aa0eda8f3$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $6479b98aa0eda8f3$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $6479b98aa0eda8f3$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $6479b98aa0eda8f3$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $6479b98aa0eda8f3$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $6479b98aa0eda8f3$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $6479b98aa0eda8f3$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("cF0Fs", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $9379d4ef3f8bf4c2$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kiN9d = parcelRequire("kiN9d");

var $an8Qp = parcelRequire("an8Qp");

var $8CPnn = parcelRequire("8CPnn");
var $9379d4ef3f8bf4c2$var$EMPTY_MODIFIERS = [];
var $9379d4ef3f8bf4c2$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $9379d4ef3f8bf4c2$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $8CPnn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $8CPnn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $8CPnn.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $8CPnn.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $kiN9d.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("kiN9d", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $ec7b9cc478c50c56$export$8f7491d57c8f97a9);

var $bCYNJ = parcelRequire("bCYNJ");

var $9VFc8 = parcelRequire("9VFc8");

var $eSCm4 = parcelRequire("eSCm4");

var $auISw = parcelRequire("auISw");

var $jyJjm = parcelRequire("jyJjm");

var $dbrK2 = parcelRequire("dbrK2");

var $4SPbW = parcelRequire("4SPbW");

var $h9iBj = parcelRequire("h9iBj");

var $cXK59 = parcelRequire("cXK59");

var $9ORaO = parcelRequire("9ORaO");


var $ec7b9cc478c50c56$export$d34966752335dd47 = [
    (0, $9VFc8.default),
    (0, $eSCm4.default),
    (0, $auISw.default),
    (0, $jyJjm.default),
    (0, $dbrK2.default),
    (0, $4SPbW.default),
    (0, $h9iBj.default),
    (0, $cXK59.default),
    (0, $9ORaO.default)
];
var $ec7b9cc478c50c56$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bCYNJ.popperGenerator)({
    defaultModifiers: $ec7b9cc478c50c56$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bCYNJ", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $8772682d2ffee00b$export$ed5e13716264f202);

var $1vbRX = parcelRequire("1vbRX");

var $3IKSM = parcelRequire("3IKSM");

var $3FJn5 = parcelRequire("3FJn5");

var $bBy4C = parcelRequire("bBy4C");

var $lLPoF = parcelRequire("lLPoF");

var $ee8pR = parcelRequire("ee8pR");

var $7jaD4 = parcelRequire("7jaD4");


var $6C3Up = parcelRequire("6C3Up");
var $8772682d2ffee00b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $8772682d2ffee00b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $8772682d2ffee00b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8772682d2ffee00b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $8772682d2ffee00b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6C3Up.isElement)(reference) ? (0, $3FJn5.default)(reference) : reference.contextElement ? (0, $3FJn5.default)(reference.contextElement) : [],
                    popper: (0, $3FJn5.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $lLPoF.default)((0, $7jaD4.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8772682d2ffee00b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1vbRX.default)(reference, (0, $bBy4C.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3IKSM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $ee8pR.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8772682d2ffee00b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8772682d2ffee00b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8772682d2ffee00b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("1vbRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1181e4b083131e42$export$2e2bcd8739ae039);

var $94kXO = parcelRequire("94kXO");

var $gK7NZ = parcelRequire("gK7NZ");

var $dG7HZ = parcelRequire("dG7HZ");

var $6C3Up = parcelRequire("6C3Up");

var $fy9Px = parcelRequire("fy9Px");

var $8Ak0z = parcelRequire("8Ak0z");

var $8fPlp = parcelRequire("8fPlp");

var $df9tg = parcelRequire("df9tg");
function $1181e4b083131e42$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $df9tg.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $df9tg.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1181e4b083131e42$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6C3Up.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $6C3Up.isHTMLElement)(offsetParent) && $1181e4b083131e42$var$isElementScaled(offsetParent);
    var documentElement = (0, $8Ak0z.default)(offsetParent);
    var rect = (0, $94kXO.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dG7HZ.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8fPlp.default)(documentElement)) scroll = (0, $gK7NZ.default)(offsetParent);
        if ((0, $6C3Up.isHTMLElement)(offsetParent)) {
            offsets = (0, $94kXO.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $fy9Px.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("94kXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a4bfc2265992e6$export$2e2bcd8739ae039);

var $6C3Up = parcelRequire("6C3Up");

var $df9tg = parcelRequire("df9tg");

var $goIbd = parcelRequire("goIbd");

var $lc7kP = parcelRequire("lc7kP");
function $69a4bfc2265992e6$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6C3Up.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $df9tg.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $df9tg.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6C3Up.isElement)(element) ? (0, $goIbd.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $lc7kP.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("6C3Up", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $4d0952e59acca439$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $4d0952e59acca439$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $4d0952e59acca439$export$af51f0f06c0f328a);

var $goIbd = parcelRequire("goIbd");
function $4d0952e59acca439$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $goIbd.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $4d0952e59acca439$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $goIbd.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $4d0952e59acca439$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $goIbd.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("goIbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf01286fa66f232a$export$2e2bcd8739ae039);
function $bf01286fa66f232a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("df9tg", function(module, exports) {

$parcel$export(module.exports, "max", () => $9a4405cce7f6efcc$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $9a4405cce7f6efcc$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $9a4405cce7f6efcc$export$2077e0241d6afd3c);
var $9a4405cce7f6efcc$export$8960430cfd85939f = Math.max;
var $9a4405cce7f6efcc$export$96ec731ed4dcb222 = Math.min;
var $9a4405cce7f6efcc$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("lc7kP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e06882007a8581$export$2e2bcd8739ae039);

var $lGsPk = parcelRequire("lGsPk");
function $f6e06882007a8581$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $lGsPk.default)());
}

});
parcelRegister("lGsPk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc93e19cbbcf9623$export$2e2bcd8739ae039);
function $fc93e19cbbcf9623$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("gK7NZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c306ff2981b76570$export$2e2bcd8739ae039);

var $743U8 = parcelRequire("743U8");

var $goIbd = parcelRequire("goIbd");

var $6C3Up = parcelRequire("6C3Up");

var $5nDKj = parcelRequire("5nDKj");
function $c306ff2981b76570$export$2e2bcd8739ae039(node) {
    if (node === (0, $goIbd.default)(node) || !(0, $6C3Up.isHTMLElement)(node)) return (0, $743U8.default)(node);
    else return (0, $5nDKj.default)(node);
}

});
parcelRegister("743U8", function(module, exports) {

$parcel$export(module.exports, "default", () => $524bef6ef03db84f$export$2e2bcd8739ae039);

var $goIbd = parcelRequire("goIbd");
function $524bef6ef03db84f$export$2e2bcd8739ae039(node) {
    var win = (0, $goIbd.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("5nDKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eadee71c34e0225$export$2e2bcd8739ae039);
function $3eadee71c34e0225$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("dG7HZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f552d5c91295df3$export$2e2bcd8739ae039);
function $9f552d5c91295df3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("fy9Px", function(module, exports) {

$parcel$export(module.exports, "default", () => $b521a816094082e2$export$2e2bcd8739ae039);

var $94kXO = parcelRequire("94kXO");

var $8Ak0z = parcelRequire("8Ak0z");

var $743U8 = parcelRequire("743U8");
function $b521a816094082e2$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $94kXO.default)((0, $8Ak0z.default)(element)).left + (0, $743U8.default)(element).scrollLeft;
}

});
parcelRegister("8Ak0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $640134c228f545fa$export$2e2bcd8739ae039);

var $6C3Up = parcelRequire("6C3Up");
function $640134c228f545fa$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6C3Up.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("8fPlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $60278d5e65144273$export$2e2bcd8739ae039);

var $d9bWE = parcelRequire("d9bWE");
function $60278d5e65144273$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d9bWE.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("d9bWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $992561a64f31eeef$export$2e2bcd8739ae039);

var $goIbd = parcelRequire("goIbd");
function $992561a64f31eeef$export$2e2bcd8739ae039(element) {
    return (0, $goIbd.default)(element).getComputedStyle(element);
}

});



parcelRegister("3IKSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b59d91063360302$export$2e2bcd8739ae039);

var $94kXO = parcelRequire("94kXO");
function $2b59d91063360302$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $94kXO.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("3FJn5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac8653e1dc7297c$export$2e2bcd8739ae039);

var $liAUD = parcelRequire("liAUD");

var $c2ho0 = parcelRequire("c2ho0");

var $goIbd = parcelRequire("goIbd");

var $8fPlp = parcelRequire("8fPlp");
function $2ac8653e1dc7297c$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $liAUD.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $goIbd.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8fPlp.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2ac8653e1dc7297c$export$2e2bcd8739ae039((0, $c2ho0.default)(target)));
}

});
parcelRegister("liAUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f817e975f63520fc$export$2e2bcd8739ae039);

var $c2ho0 = parcelRequire("c2ho0");

var $8fPlp = parcelRequire("8fPlp");

var $dG7HZ = parcelRequire("dG7HZ");

var $6C3Up = parcelRequire("6C3Up");
function $f817e975f63520fc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $dG7HZ.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6C3Up.isHTMLElement)(node) && (0, $8fPlp.default)(node)) return node;
    return $f817e975f63520fc$export$2e2bcd8739ae039((0, $c2ho0.default)(node));
}

});
parcelRegister("c2ho0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c332879cf2f13be$export$2e2bcd8739ae039);

var $dG7HZ = parcelRequire("dG7HZ");

var $8Ak0z = parcelRequire("8Ak0z");

var $6C3Up = parcelRequire("6C3Up");
function $8c332879cf2f13be$export$2e2bcd8739ae039(element) {
    if ((0, $dG7HZ.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6C3Up.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8Ak0z.default)(element) // fallback
    );
}

});



parcelRegister("bBy4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $872d94b3c021437a$export$2e2bcd8739ae039);

var $goIbd = parcelRequire("goIbd");

var $dG7HZ = parcelRequire("dG7HZ");

var $d9bWE = parcelRequire("d9bWE");

var $6C3Up = parcelRequire("6C3Up");

var $7oL3m = parcelRequire("7oL3m");

var $c2ho0 = parcelRequire("c2ho0");

var $lGsPk = parcelRequire("lGsPk");
function $872d94b3c021437a$var$getTrueOffsetParent(element) {
    if (!(0, $6C3Up.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d9bWE.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $872d94b3c021437a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $lGsPk.default)());
    var isIE = /Trident/i.test((0, $lGsPk.default)());
    if (isIE && (0, $6C3Up.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d9bWE.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c2ho0.default)(element);
    if ((0, $6C3Up.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $6C3Up.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $dG7HZ.default)(currentNode)) < 0){
        var css = (0, $d9bWE.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $872d94b3c021437a$export$2e2bcd8739ae039(element) {
    var window = (0, $goIbd.default)(element);
    var offsetParent = $872d94b3c021437a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7oL3m.default)(offsetParent) && (0, $d9bWE.default)(offsetParent).position === 'static')offsetParent = $872d94b3c021437a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dG7HZ.default)(offsetParent) === 'html' || (0, $dG7HZ.default)(offsetParent) === 'body' && (0, $d9bWE.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $872d94b3c021437a$var$getContainingBlock(element) || window;
}

});
parcelRegister("7oL3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $562f46131eaaae1d$export$2e2bcd8739ae039);

var $dG7HZ = parcelRequire("dG7HZ");
function $562f46131eaaae1d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $dG7HZ.default)(element)) >= 0;
}

});


parcelRegister("lLPoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd95db18d67800d3$export$2e2bcd8739ae039);

var $gqhoH = parcelRequire("gqhoH");
function $fd95db18d67800d3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $fd95db18d67800d3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $fd95db18d67800d3$var$order(modifiers); // order based on phase
    return (0, $gqhoH.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("ee8pR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5b8e6bd9779cd63$export$2e2bcd8739ae039);
function $a5b8e6bd9779cd63$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("7jaD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $55228d768f6998e8$export$2e2bcd8739ae039);
function $55228d768f6998e8$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("9VFc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a96456ae231684$export$2e2bcd8739ae039);

var $goIbd = parcelRequire("goIbd");
var $73a96456ae231684$var$passive = {
    passive: true
};
function $73a96456ae231684$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $goIbd.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $73a96456ae231684$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $73a96456ae231684$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $73a96456ae231684$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $73a96456ae231684$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $73a96456ae231684$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $73a96456ae231684$var$effect,
    data: {}
};

});

parcelRegister("eSCm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad53dc585ce20250$export$2e2bcd8739ae039);

var $57YPS = parcelRequire("57YPS");
function $ad53dc585ce20250$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $57YPS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ad53dc585ce20250$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ad53dc585ce20250$var$popperOffsets,
    data: {}
};

});
parcelRegister("57YPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbccbe5aaf766ed$export$2e2bcd8739ae039);

var $hASly = parcelRequire("hASly");

var $4EXT0 = parcelRequire("4EXT0");

var $hCcKR = parcelRequire("hCcKR");

var $gqhoH = parcelRequire("gqhoH");
function $3bbccbe5aaf766ed$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hASly.default)(placement) : null;
    var variation = placement ? (0, $4EXT0.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $gqhoH.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $gqhoH.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $gqhoH.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $gqhoH.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $hCcKR.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $gqhoH.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $gqhoH.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hASly", function(module, exports) {

$parcel$export(module.exports, "default", () => $cceff48da07818fc$export$2e2bcd8739ae039);

function $cceff48da07818fc$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("4EXT0", function(module, exports) {

$parcel$export(module.exports, "default", () => $364959fe082c2249$export$2e2bcd8739ae039);
function $364959fe082c2249$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("hCcKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2fe125055ddbda$export$2e2bcd8739ae039);
function $cd2fe125055ddbda$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("auISw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3f84a19a29ac33$export$2e2bcd8739ae039);

var $gqhoH = parcelRequire("gqhoH");

var $bBy4C = parcelRequire("bBy4C");

var $goIbd = parcelRequire("goIbd");

var $8Ak0z = parcelRequire("8Ak0z");

var $d9bWE = parcelRequire("d9bWE");

var $hASly = parcelRequire("hASly");

var $4EXT0 = parcelRequire("4EXT0");

var $df9tg = parcelRequire("df9tg");
var $7a3f84a19a29ac33$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7a3f84a19a29ac33$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $df9tg.round)(x * dpr) / dpr || 0,
        y: (0, $df9tg.round)(y * dpr) / dpr || 0
    };
}
function $7a3f84a19a29ac33$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $gqhoH.left);
    var sideY = (0, $gqhoH.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $bBy4C.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $goIbd.default)(popper)) {
            offsetParent = (0, $8Ak0z.default)(popper);
            if ((0, $d9bWE.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $gqhoH.top) || (placement === (0, $gqhoH.left) || placement === (0, $gqhoH.right)) && variation === (0, $gqhoH.end)) {
            sideY = (0, $gqhoH.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $gqhoH.left) || (placement === (0, $gqhoH.top) || placement === (0, $gqhoH.bottom)) && variation === (0, $gqhoH.end)) {
            sideX = (0, $gqhoH.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7a3f84a19a29ac33$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7a3f84a19a29ac33$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $goIbd.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $7a3f84a19a29ac33$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $hASly.default)(state.placement),
        variation: (0, $4EXT0.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7a3f84a19a29ac33$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7a3f84a19a29ac33$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7a3f84a19a29ac33$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $7a3f84a19a29ac33$var$computeStyles,
    data: {}
};

});

parcelRegister("jyJjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d4572a23bc608c$export$2e2bcd8739ae039);

var $dG7HZ = parcelRequire("dG7HZ");

var $6C3Up = parcelRequire("6C3Up");
// and applies them to the HTMLElements such as popper and arrow
function $e3d4572a23bc608c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6C3Up.isHTMLElement)(element) || !(0, $dG7HZ.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $e3d4572a23bc608c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6C3Up.isHTMLElement)(element) || !(0, $dG7HZ.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $e3d4572a23bc608c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $e3d4572a23bc608c$var$applyStyles,
    effect: $e3d4572a23bc608c$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("dbrK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9991d2591691d6af$export$2e2bcd8739ae039);

var $hASly = parcelRequire("hASly");

var $gqhoH = parcelRequire("gqhoH");
function $9991d2591691d6af$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hASly.default)(placement);
    var invertDistance = [
        (0, $gqhoH.left),
        (0, $gqhoH.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $gqhoH.left),
        (0, $gqhoH.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9991d2591691d6af$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $gqhoH.placements).reduce(function(acc, placement) {
        acc[placement] = $9991d2591691d6af$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9991d2591691d6af$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $9991d2591691d6af$var$offset
};

});

parcelRegister("4SPbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e3ea2a27db3dcb$export$2e2bcd8739ae039);

var $03glJ = parcelRequire("03glJ");

var $hASly = parcelRequire("hASly");

var $aDS5W = parcelRequire("aDS5W");

var $gyndU = parcelRequire("gyndU");

var $lMrHN = parcelRequire("lMrHN");

var $gqhoH = parcelRequire("gqhoH");

var $4EXT0 = parcelRequire("4EXT0");
function $38e3ea2a27db3dcb$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hASly.default)(placement) === (0, $gqhoH.auto)) return [];
    var oppositePlacement = (0, $03glJ.default)(placement);
    return [
        (0, $aDS5W.default)(placement),
        oppositePlacement,
        (0, $aDS5W.default)(oppositePlacement)
    ];
}
function $38e3ea2a27db3dcb$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hASly.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $03glJ.default)(preferredPlacement)
    ] : $38e3ea2a27db3dcb$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hASly.default)(placement) === (0, $gqhoH.auto) ? (0, $lMrHN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hASly.default)(placement);
        var isStartVariation = (0, $4EXT0.default)(placement) === (0, $gqhoH.start);
        var isVertical = [
            (0, $gqhoH.top),
            (0, $gqhoH.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gyndU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $gqhoH.right) : (0, $gqhoH.left) : isStartVariation ? (0, $gqhoH.bottom) : (0, $gqhoH.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $03glJ.default)(mainVariationSide);
        var altVariationSide = (0, $03glJ.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $38e3ea2a27db3dcb$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $38e3ea2a27db3dcb$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("03glJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $009cf69c875b4998$export$2e2bcd8739ae039);
var $009cf69c875b4998$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $009cf69c875b4998$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $009cf69c875b4998$var$hash[matched];
    });
}

});

parcelRegister("aDS5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf781fc138c9555$export$2e2bcd8739ae039);
var $7bf781fc138c9555$var$hash = {
    start: 'end',
    end: 'start'
};
function $7bf781fc138c9555$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $7bf781fc138c9555$var$hash[matched];
    });
}

});

parcelRegister("gyndU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d1d5f90aa0be88$export$2e2bcd8739ae039);

var $dcqHa = parcelRequire("dcqHa");

var $8Ak0z = parcelRequire("8Ak0z");

var $94kXO = parcelRequire("94kXO");

var $57YPS = parcelRequire("57YPS");

var $2blrY = parcelRequire("2blrY");

var $gqhoH = parcelRequire("gqhoH");

var $6C3Up = parcelRequire("6C3Up");

var $cQ3cU = parcelRequire("cQ3cU");

var $WyOJK = parcelRequire("WyOJK");
function $c0d1d5f90aa0be88$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $gqhoH.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $gqhoH.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $gqhoH.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cQ3cU.default)(typeof padding !== 'number' ? padding : (0, $WyOJK.default)(padding, (0, $gqhoH.basePlacements)));
    var altContext = elementContext === (0, $gqhoH.popper) ? (0, $gqhoH.reference) : (0, $gqhoH.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dcqHa.default)((0, $6C3Up.isElement)(element) ? element : element.contextElement || (0, $8Ak0z.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $94kXO.default)(state.elements.reference);
    var popperOffsets = (0, $57YPS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2blrY.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $gqhoH.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $gqhoH.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $gqhoH.right),
                (0, $gqhoH.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $gqhoH.top),
                (0, $gqhoH.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dcqHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c11a7b0ab5d399$export$2e2bcd8739ae039);

var $gqhoH = parcelRequire("gqhoH");

var $01eFd = parcelRequire("01eFd");

var $bKnIY = parcelRequire("bKnIY");

var $3FJn5 = parcelRequire("3FJn5");

var $bBy4C = parcelRequire("bBy4C");

var $8Ak0z = parcelRequire("8Ak0z");

var $d9bWE = parcelRequire("d9bWE");

var $6C3Up = parcelRequire("6C3Up");

var $94kXO = parcelRequire("94kXO");

var $c2ho0 = parcelRequire("c2ho0");

var $imp8q = parcelRequire("imp8q");

var $dG7HZ = parcelRequire("dG7HZ");

var $2blrY = parcelRequire("2blrY");

var $df9tg = parcelRequire("df9tg");
function $99c11a7b0ab5d399$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $94kXO.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $99c11a7b0ab5d399$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $gqhoH.viewport) ? (0, $2blrY.default)((0, $01eFd.default)(element, strategy)) : (0, $6C3Up.isElement)(clippingParent) ? $99c11a7b0ab5d399$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2blrY.default)((0, $bKnIY.default)((0, $8Ak0z.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $99c11a7b0ab5d399$var$getClippingParents(element) {
    var clippingParents = (0, $3FJn5.default)((0, $c2ho0.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d9bWE.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6C3Up.isHTMLElement)(element) ? (0, $bBy4C.default)(element) : element;
    if (!(0, $6C3Up.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6C3Up.isElement)(clippingParent) && (0, $imp8q.default)(clippingParent, clipperElement) && (0, $dG7HZ.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $99c11a7b0ab5d399$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $99c11a7b0ab5d399$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $99c11a7b0ab5d399$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $df9tg.max)(rect.top, accRect.top);
        accRect.right = (0, $df9tg.min)(rect.right, accRect.right);
        accRect.bottom = (0, $df9tg.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $df9tg.max)(rect.left, accRect.left);
        return accRect;
    }, $99c11a7b0ab5d399$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("01eFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $003b780bae3ad9fb$export$2e2bcd8739ae039);

var $goIbd = parcelRequire("goIbd");

var $8Ak0z = parcelRequire("8Ak0z");

var $fy9Px = parcelRequire("fy9Px");

var $lc7kP = parcelRequire("lc7kP");
function $003b780bae3ad9fb$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $goIbd.default)(element);
    var html = (0, $8Ak0z.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $lc7kP.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $fy9Px.default)(element),
        y: y
    };
}

});

parcelRegister("bKnIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d664c0b30321ec$export$2e2bcd8739ae039);

var $8Ak0z = parcelRequire("8Ak0z");

var $d9bWE = parcelRequire("d9bWE");

var $fy9Px = parcelRequire("fy9Px");

var $743U8 = parcelRequire("743U8");

var $df9tg = parcelRequire("df9tg");
function $88d664c0b30321ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8Ak0z.default)(element);
    var winScroll = (0, $743U8.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $df9tg.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $df9tg.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $fy9Px.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d9bWE.default)(body || html).direction === 'rtl') x += (0, $df9tg.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("imp8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ddc757c06275d5$export$2e2bcd8739ae039);

var $6C3Up = parcelRequire("6C3Up");
function $d5ddc757c06275d5$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6C3Up.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("2blrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $196d3f65b1a1ca99$export$2e2bcd8739ae039);
function $196d3f65b1a1ca99$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cQ3cU", function(module, exports) {

$parcel$export(module.exports, "default", () => $958cd440bb063a0b$export$2e2bcd8739ae039);

var $dXac2 = parcelRequire("dXac2");
function $958cd440bb063a0b$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dXac2.default)(), paddingObject);
}

});
parcelRegister("dXac2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a288b12f3ce5fe67$export$2e2bcd8739ae039);
function $a288b12f3ce5fe67$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("WyOJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b006ce47bfab294$export$2e2bcd8739ae039);
function $0b006ce47bfab294$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("lMrHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb392628ca2cc0d$export$2e2bcd8739ae039);

var $4EXT0 = parcelRequire("4EXT0");

var $gqhoH = parcelRequire("gqhoH");

var $gyndU = parcelRequire("gyndU");

var $hASly = parcelRequire("hASly");
function $fdb392628ca2cc0d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $gqhoH.placements) : _options$allowedAutoP;
    var variation = (0, $4EXT0.default)(placement);
    var placements = variation ? flipVariations ? (0, $gqhoH.variationPlacements) : (0, $gqhoH.variationPlacements).filter(function(placement) {
        return (0, $4EXT0.default)(placement) === variation;
    }) : (0, $gqhoH.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gyndU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hASly.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("h9iBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c1b4a9cf9b941f$export$2e2bcd8739ae039);

var $gqhoH = parcelRequire("gqhoH");

var $hASly = parcelRequire("hASly");

var $hCcKR = parcelRequire("hCcKR");

var $8EcP2 = parcelRequire("8EcP2");

var $5Bac3 = parcelRequire("5Bac3");

var $3IKSM = parcelRequire("3IKSM");

var $bBy4C = parcelRequire("bBy4C");

var $gyndU = parcelRequire("gyndU");

var $4EXT0 = parcelRequire("4EXT0");

var $dXac2 = parcelRequire("dXac2");

var $df9tg = parcelRequire("df9tg");
function $c7c1b4a9cf9b941f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gyndU.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hASly.default)(state.placement);
    var variation = (0, $4EXT0.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $hCcKR.default)(basePlacement);
    var altAxis = (0, $8EcP2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $gqhoH.top) : (0, $gqhoH.left);
        var altSide = mainAxis === 'y' ? (0, $gqhoH.bottom) : (0, $gqhoH.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $gqhoH.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $gqhoH.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3IKSM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dXac2.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5Bac3.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $bBy4C.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5Bac3.within)(tether ? (0, $df9tg.min)(min, tetherMin) : min, offset, tether ? (0, $df9tg.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $gqhoH.top) : (0, $gqhoH.left);
        var _altSide = mainAxis === 'x' ? (0, $gqhoH.bottom) : (0, $gqhoH.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $gqhoH.top),
            (0, $gqhoH.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5Bac3.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $5Bac3.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c7c1b4a9cf9b941f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $c7c1b4a9cf9b941f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8EcP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $019fef81898179a4$export$2e2bcd8739ae039);
function $019fef81898179a4$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("5Bac3", function(module, exports) {

$parcel$export(module.exports, "within", () => $413850a1431c3bb6$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $413850a1431c3bb6$export$86c8af6d3ef0b4a);

var $df9tg = parcelRequire("df9tg");
function $413850a1431c3bb6$export$f28d906d67a997f3(min, value, max) {
    return (0, $df9tg.max)(min, (0, $df9tg.min)(value, max));
}
function $413850a1431c3bb6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $413850a1431c3bb6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("cXK59", function(module, exports) {

$parcel$export(module.exports, "default", () => $96febdaaece17c6c$export$2e2bcd8739ae039);

var $hASly = parcelRequire("hASly");

var $3IKSM = parcelRequire("3IKSM");

var $imp8q = parcelRequire("imp8q");

var $bBy4C = parcelRequire("bBy4C");

var $hCcKR = parcelRequire("hCcKR");

var $5Bac3 = parcelRequire("5Bac3");

var $cQ3cU = parcelRequire("cQ3cU");

var $WyOJK = parcelRequire("WyOJK");

var $gqhoH = parcelRequire("gqhoH");
var $96febdaaece17c6c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cQ3cU.default)(typeof padding !== 'number' ? padding : (0, $WyOJK.default)(padding, (0, $gqhoH.basePlacements)));
};
function $96febdaaece17c6c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hASly.default)(state.placement);
    var axis = (0, $hCcKR.default)(basePlacement);
    var isVertical = [
        (0, $gqhoH.left),
        (0, $gqhoH.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $96febdaaece17c6c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3IKSM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $gqhoH.top) : (0, $gqhoH.left);
    var maxProp = axis === 'y' ? (0, $gqhoH.bottom) : (0, $gqhoH.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $bBy4C.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5Bac3.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $96febdaaece17c6c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $imp8q.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $96febdaaece17c6c$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $96febdaaece17c6c$var$arrow,
    effect: $96febdaaece17c6c$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("9ORaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $726207b15572ad3d$export$2e2bcd8739ae039);

var $gqhoH = parcelRequire("gqhoH");

var $gyndU = parcelRequire("gyndU");
function $726207b15572ad3d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $726207b15572ad3d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $gqhoH.top),
        (0, $gqhoH.right),
        (0, $gqhoH.bottom),
        (0, $gqhoH.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $726207b15572ad3d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gyndU.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gyndU.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $726207b15572ad3d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $726207b15572ad3d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $726207b15572ad3d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $726207b15572ad3d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $726207b15572ad3d$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $726207b15572ad3d$var$hide
};

});





parcelRegister("6frYP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $48c9d9131934514f$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $8nlzU = parcelRequire("8nlzU");

var $8CPnn = parcelRequire("8CPnn");
function $48c9d9131934514f$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $8nlzU.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $8CPnn.setRef)(innerRef, node);
        (0, $8CPnn.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $8CPnn.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $8CPnn.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("i49pH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26fe705432a051a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("9ZrlJ")).FeatureGateEnvironment);

var $5zQU9 = parcelRequire("5zQU9");

var $avKkz = parcelRequire("avKkz");

var $7yvNz = parcelRequire("7yvNz");

var $9ZrlJ = parcelRequire("9ZrlJ");

const $d26fe705432a051a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $d26fe705432a051a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $d26fe705432a051a$var$FeatureGates {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ static async initialize(clientOptions, identifiers, customAttributes) {
        if ($d26fe705432a051a$var$FeatureGates.initPromise) {
            if (!$d26fe705432a051a$var$FeatureGates.shallowEquals(clientOptions, $d26fe705432a051a$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $d26fe705432a051a$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $d26fe705432a051a$var$FeatureGates.initOptions = clientOptions;
        $d26fe705432a051a$var$FeatureGates.initPromise = $d26fe705432a051a$var$FeatureGates.init(clientOptions, identifiers, customAttributes).then(()=>{
            $d26fe705432a051a$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $d26fe705432a051a$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $d26fe705432a051a$var$FeatureGates.initCompleted, clientOptions.apiKey);
        });
        return $d26fe705432a051a$var$FeatureGates.initPromise;
    }
    static fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _FeatureGates$initOpt;
        (_FeatureGates$initOpt = $d26fe705432a051a$var$FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: $d26fe705432a051a$var$FeatureGates.initOptions.targetApp,
                clientVersion: (0, $3e55effaa3b38112$export$a59f8d67326bd1cb),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if ($d26fe705432a051a$var$FeatureGates.initOptions.environment !== (0, $9ZrlJ.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        if ($d26fe705432a051a$var$FeatureGates.initPromise) {
            if (!$d26fe705432a051a$var$FeatureGates.shallowEquals(clientOptions, $d26fe705432a051a$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $d26fe705432a051a$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $d26fe705432a051a$var$FeatureGates.initOptions = clientOptions;
        $d26fe705432a051a$var$FeatureGates.initPromise = $d26fe705432a051a$var$FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(()=>{
            $d26fe705432a051a$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $d26fe705432a051a$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', $d26fe705432a051a$var$FeatureGates.initCompleted);
        });
        return $d26fe705432a051a$var$FeatureGates.initPromise;
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ static async updateUser(fetchOptions, identifiers, customAttributes) {
        const initializeValuesProducer = ()=>(0, $7yvNz.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await $d26fe705432a051a$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await $d26fe705432a051a$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    static initializeCalled() {
        return $d26fe705432a051a$var$FeatureGates.initPromise != null;
    }
    static initializeCompleted() {
        return $d26fe705432a051a$var$FeatureGates.initCompleted;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ static checkGate(gateName, options = {}) {
        try {
            const { fireGateExposure: fireGateExposure = true } = options;
            const evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(gateName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$d26fe705432a051a$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $d26fe705432a051a$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link FeatureGates.checkGate} where <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ static manuallyLogGateExposure(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogGateExposure(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = FeatureGates.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ static getExperiment(experimentName, options = {}) {
        try {
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            const evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(experimentName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$d26fe705432a051a$var$FeatureGates.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                $d26fe705432a051a$var$FeatureGates.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $avKkz.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $avKkz.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
    const isValidColor: ValidColorTypeCheck =
      (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
    const buttonColor: ValidColor = FeatureGates.getExperimentValue(
      'example-experiment-name',
      'backgroundColor',
      'yellow',
      {
          typeGuard: isValidColor
      }
   );
   ```
  */ static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = $d26fe705432a051a$var$FeatureGates.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$d26fe705432a051a$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                $d26fe705432a051a$var$FeatureGates.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link FeatureGates.getExperimentValue} or
   * {@link FeatureGates.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ static manuallyLogExperimentExposure(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogExperimentExposure(experimentName);
    }
    static shutdownStatsig() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to build
   * your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearGateOverride} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ static overrideGate(gateName, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, value);
    }
    /**
   * Removes any overrides that have been set for the given gate.
   * @param {string} gateName
   */ static clearGateOverride(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, null);
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment names to build
   * your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearConfigOverride} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ static overrideConfig(experimentName, values) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, values);
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ static clearConfigOverride(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, null);
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been added
   * via prior calls to {@link FeatureGates.overrideConfig} or {@link FeatureGates.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearAllOverrides} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {object} overrides
   */ static setOverrides(overrides) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides({
            gates: {},
            configs: {},
            layers: {},
            ...overrides
        });
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ static getOverrides() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ static clearAllOverrides() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides(null);
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link FeatureGates.updateUser} or {@link FeatureGates.updateUserWithValues}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ static isCurrentUser(identifiers, customAttributes) {
        return $d26fe705432a051a$var$FeatureGates.shallowEquals($d26fe705432a051a$var$FeatureGates.currentIdentifiers, identifiers) && $d26fe705432a051a$var$FeatureGates.shallowEquals($d26fe705432a051a$var$FeatureGates.currentAttributes, customAttributes);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ static async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
            // values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $7yvNz.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $7yvNz.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client with experiment
            // values if both requests are successful. Else an error would be thrown and handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await $d26fe705432a051a$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const user = this.toStatsigUser(identifiers, customAttributes);
        $d26fe705432a051a$var$FeatureGates.currentIdentifiers = identifiers;
        $d26fe705432a051a$var$FeatureGates.currentAttributes = customAttributes;
        if (!clientOptions.sdkKey) clientOptions.sdkKey = $d26fe705432a051a$var$DEFAULT_CLIENT_KEY;
        if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $d26fe705432a051a$var$DEFAULT_EVENT_LOGGING_API;
        if (clientOptions.perimeter === (0, $9ZrlJ.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        clientOptions.disableAllLogging = true;
        const { sdkKey: sdkKey } = clientOptions;
        const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
        try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize(sdkKey, user, statsigOptions);
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize($d26fe705432a051a$var$DEFAULT_CLIENT_KEY, user, {
                ...statsigOptions,
                initializeValues: {}
            });
            throw error;
        }
    }
    /**
   * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
   *
   * @param identifiers
   * @param customAttributes
   * @private
   */ static toStatsigUser(identifiers, customAttributes) {
        const user = {
            customIDs: identifiers,
            custom: customAttributes
        };
        if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
        return user;
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        if (!$d26fe705432a051a$var$FeatureGates.initPromise) throw new Error('The FeatureGates client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if ($d26fe705432a051a$var$FeatureGates.isCurrentUser(identifiers, customAttributes)) return $d26fe705432a051a$var$FeatureGates.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = $d26fe705432a051a$var$FeatureGates.initPromise;
        try {
            await $d26fe705432a051a$var$FeatureGates.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = $d26fe705432a051a$var$FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this point.
        // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
        $d26fe705432a051a$var$FeatureGates.initPromise = updateUserPromise.catch(()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            $d26fe705432a051a$var$FeatureGates.initPromise = originalInitPromise;
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = $d26fe705432a051a$var$FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            var _FeatureGates$initOpt2, _FeatureGates$initOpt3;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = $d26fe705432a051a$var$FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
            throw err;
        }
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).updateUserWithValues(user, initializeValues.experimentValues);
        if (success) {
            $d26fe705432a051a$var$FeatureGates.currentIdentifiers = identifiers;
            $d26fe705432a051a$var$FeatureGates.currentAttributes = customAttributes;
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * This method transforms the options given by the user into the format accepted by the Statsig client.
   *
   * @param options
   * @param {Record<string, unknown>} initializeValues
   * @private
   */ static toStatsigOptions(options, initializeValues) {
        const { sdkKey: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sdkKey, updateUserCompletionCallback: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUserCompletionCallback, perimeter: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        perimeter, ...restClientOptions } = options;
        return {
            ...restClientOptions,
            initializeValues: initializeValues,
            environment: {
                tier: options.environment
            },
            disableCurrentPageLogging: true,
            ...options.updateUserCompletionCallback && {
                updateUserCompletionCallback: $d26fe705432a051a$var$FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
            }
        };
    }
    /**
   * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
   *
   * @param callback
   * @private
   */ static toStatsigUpdateUserCompletionCallback(callback) {
        /**
     * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
     * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
     * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
     */ return (_duration, success, message)=>{
            callback(success, message);
        };
    }
    static shallowEquals(objectA, objectB) {
        if (!objectA && !objectB) return true;
        if (!objectA || !objectB) return false;
        const aEntries = Object.entries(objectA);
        const bEntries = Object.entries(objectB);
        if (aEntries.length !== bEntries.length) return false;
        const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
        aEntries.sort(ascendingKeyOrder);
        bEntries.sort(ascendingKeyOrder);
        for(let i = 0; i < aEntries.length; i++){
            const [, aValue] = aEntries[i];
            const [, bValue] = bEntries[i];
            if (aValue !== bValue) return false;
        }
        return true;
    }
    /**
   * @returns string version of the current package in semver style.
   */ static getPackageVersion() {
        return 0, $3e55effaa3b38112$export$a59f8d67326bd1cb;
    }
}
(0, $5zQU9.default)($d26fe705432a051a$var$FeatureGates, "initPromise", null);
(0, $5zQU9.default)($d26fe705432a051a$var$FeatureGates, "initCompleted", false);
(0, $5zQU9.default)($d26fe705432a051a$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, $5zQU9.default)($d26fe705432a051a$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $5zQU9.default)($d26fe705432a051a$var$FeatureGates, "hasCheckGateErrorOccurred", false);
let $d26fe705432a051a$var$boundFGJS = $d26fe705432a051a$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d26fe705432a051a$var$FeatureGates;
    else {
        var $d26fe705432a051a$var$_boundFGJS, $d26fe705432a051a$var$_boundFGJS$getPackage;
        $d26fe705432a051a$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($d26fe705432a051a$var$_boundFGJS = $d26fe705432a051a$var$boundFGJS) === null || $d26fe705432a051a$var$_boundFGJS === void 0 ? void 0 : ($d26fe705432a051a$var$_boundFGJS$getPackage = $d26fe705432a051a$var$_boundFGJS.getPackageVersion) === null || $d26fe705432a051a$var$_boundFGJS$getPackage === void 0 ? void 0 : $d26fe705432a051a$var$_boundFGJS$getPackage.call($d26fe705432a051a$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $3e55effaa3b38112$export$a59f8d67326bd1cb)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $3e55effaa3b38112$export$a59f8d67326bd1cb)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d26fe705432a051a$export$2e2bcd8739ae039 = $d26fe705432a051a$var$boundFGJS;

});
parcelRegister("7yvNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $58045fe5b9c9433a$export$2e2bcd8739ae039);

var $9ZrlJ = parcelRequire("9ZrlJ");


var $bXZSj = parcelRequire("bXZSj");
const $58045fe5b9c9433a$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $58045fe5b9c9433a$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $58045fe5b9c9433a$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $58045fe5b9c9433a$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $58045fe5b9c9433a$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $58045fe5b9c9433a$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $58045fe5b9c9433a$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $58045fe5b9c9433a$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $bXZSj.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $bXZSj.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $9ZrlJ.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $58045fe5b9c9433a$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $9ZrlJ.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $9ZrlJ.FeatureGateEnvironment).Production:
                return $58045fe5b9c9433a$export$18c93900db9358a4;
            case (0, $9ZrlJ.FeatureGateEnvironment).Staging:
                return $58045fe5b9c9433a$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $9ZrlJ.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $9ZrlJ.FeatureGateEnvironment).Development:
                return $58045fe5b9c9433a$export$f058dbf75c3bc647;
            case (0, $9ZrlJ.FeatureGateEnvironment).Staging:
                return $58045fe5b9c9433a$var$STAGING_BASE_URL;
            default:
                return $58045fe5b9c9433a$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $58045fe5b9c9433a$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $58045fe5b9c9433a$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $3e55effaa3b38112$export$a59f8d67326bd1cb),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("9ZrlJ", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $745f06958e9e7718$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $745f06958e9e7718$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options.
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ let $745f06958e9e7718$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
let $745f06958e9e7718$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});

});

const $3e55effaa3b38112$export$a59f8d67326bd1cb = "4.17.2";

parcelRegister("bXZSj", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $8b65337da1d3b1e1$export$286baf652d0b1206);
class $8b65337da1d3b1e1$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});



parcelRegister("2jDha", function(module, exports) {

$parcel$export(module.exports, "default", () => $f74b3a587370f175$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3N2S0 = parcelRequire("3N2S0");
const $f74b3a587370f175$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
            const { patchedEventProps: patchedEventProps } = (0, $3N2S0.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $f74b3a587370f175$export$2e2bcd8739ae039 = $f74b3a587370f175$var$withAnalyticsEvents;

});
parcelRegister("3N2S0", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", () => $3d1c9baf4a98311e$export$9ebb5a84d17e5d18);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");
function $3d1c9baf4a98311e$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handlerCache = (0, $eUqFw.useRef)({});
    const patchedProps = (0, $eUqFw.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("591ND", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $b725ee4b5ee94b3c$export$1a04351537078b55);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $gNgZO = parcelRequire("gNgZO");
function $b725ee4b5ee94b3c$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gNgZO.useTrackedRef)(analyticsData);
    const fnRef = (0, $gNgZO.useTrackedRef)(fn);
    const handler = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("220ac", function(module, exports) {

$parcel$export(module.exports, "default", () => $d161febbc154a5b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");

var $4Bees = parcelRequire("4Bees");

var $6bMk1 = parcelRequire("6bMk1");
var $lvz2H = parcelRequire("lvz2H");
var $hGrxl = parcelRequire("hGrxl");
var $1AYd9 = parcelRequire("1AYd9");
var $kMw7C = parcelRequire("kMw7C");
var $lueZu = parcelRequire("lueZu");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $d161febbc154a5b8$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, size: size, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bMk1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && `${testId}-button-group`
    }, secondaryAction, primaryAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lueZu.default), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "empty-state-spinner"
    }))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvz2H.default), {
        testId: testId,
        width: width || size || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMw7C.default), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1AYd9.default), {
        level: headingLevel
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hGrxl.default), null, description), actionsContainer, tertiaryAction);
};
var $d161febbc154a5b8$export$2e2bcd8739ae039 = $d161febbc154a5b8$var$EmptyState;

});
parcelRegister("6bMk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03946f46b0ffebb$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $a03946f46b0ffebb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a03946f46b0ffebb$var$actionsStyles = {
    name: "shyucn",
    styles: "display:flex;margin-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-500, 40px);align-items:center;justify-content:center"
};
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $a03946f46b0ffebb$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a03946f46b0ffebb$var$actionsStyles
    }, children);
var $a03946f46b0ffebb$export$2e2bcd8739ae039 = $a03946f46b0ffebb$var$ActionsContainer;

});

parcelRegister("lvz2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed6ea1d88cfb7b5$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $7ed6ea1d88cfb7b5$var$gridSize = (0, $lcnyw.gridSize)();
const $7ed6ea1d88cfb7b5$var$verticalMarginSize = "var(--ds-space-600, 48px)";
const $7ed6ea1d88cfb7b5$var$columnWidth = $7ed6ea1d88cfb7b5$var$gridSize * 8;
const $7ed6ea1d88cfb7b5$var$gutter = $7ed6ea1d88cfb7b5$var$gridSize * 2;
const $7ed6ea1d88cfb7b5$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `${$7ed6ea1d88cfb7b5$var$verticalMarginSize} auto`,
    textAlign: 'center'
});
/* Use max-width so the component can shrink on smaller viewports. */ const $7ed6ea1d88cfb7b5$var$wideContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$7ed6ea1d88cfb7b5$var$columnWidth * 6 + $7ed6ea1d88cfb7b5$var$gutter * 5}px`
});
const $7ed6ea1d88cfb7b5$var$narrowContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$7ed6ea1d88cfb7b5$var$columnWidth * 4 + $7ed6ea1d88cfb7b5$var$gutter * 3}px`
});
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $7ed6ea1d88cfb7b5$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $7ed6ea1d88cfb7b5$var$containerStyles,
            width === 'narrow' ? $7ed6ea1d88cfb7b5$var$narrowContainerStyles : $7ed6ea1d88cfb7b5$var$wideContainerStyles
        ]
    }, children);
var $7ed6ea1d88cfb7b5$export$2e2bcd8739ae039 = $7ed6ea1d88cfb7b5$var$Container;

});

parcelRegister("hGrxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ee6ed9c0893c17$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $e6ee6ed9c0893c17$var$descriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    marginTop: "var(--ds-space-0, 0px)",
    marginBottom: "var(--ds-space-300, 24px)",
    color: `var(--ds-text, ${(0, $PdmhA.N800)})`
});
/**
 * __Description__
 *
 * Description of Empty State.
 *
 * @internal
 */ const $e6ee6ed9c0893c17$var$Description = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("p", {
        css: $e6ee6ed9c0893c17$var$descriptionStyles
    }, children);
var $e6ee6ed9c0893c17$export$2e2bcd8739ae039 = $e6ee6ed9c0893c17$var$Description;

});

parcelRegister("1AYd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $51cad1c12322f3fd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
const $51cad1c12322f3fd$var$headerStyles = /*#__PURE__*/ (0, $byn9U.css)([
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4lTFP.h600)(),
    {
        marginTop: "var(--ds-space-0, 0px)",
        marginBottom: "var(--ds-space-200, 16px)"
    }
]);
/**
 * __Header__
 *
 * Header of Empty State.
 *
 * @internal
 */ const $51cad1c12322f3fd$var$EmptyStateHeader = ({ children: children, level: level = 4 })=>{
    const Tag = `h${level > 0 && level < 7 ? level : level > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        css: $51cad1c12322f3fd$var$headerStyles
    }, children);
};
var $51cad1c12322f3fd$export$2e2bcd8739ae039 = $51cad1c12322f3fd$var$EmptyStateHeader;

});
parcelRegister("4lTFP", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $5e611545e491da86$export$2a99220fb32ec798);
$parcel$export(module.exports, "headingSizes", () => $5e611545e491da86$export$bc02e067df412c3b);
$parcel$export(module.exports, "h900", () => $5e611545e491da86$export$bdb8f897727a9c67);
$parcel$export(module.exports, "h800", () => $5e611545e491da86$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $5e611545e491da86$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $5e611545e491da86$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $5e611545e491da86$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $5e611545e491da86$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $5e611545e491da86$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $5e611545e491da86$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $5e611545e491da86$export$dfc0e69214efdc3c);

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $5e611545e491da86$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
const $5e611545e491da86$var$baseHeading = (size, lineHeight)=>({
        fontSize: `${size / (0, $lcnyw.fontSize)()}em`,
        fontStyle: 'inherit',
        lineHeight: lineHeight / size
    });
const $5e611545e491da86$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
const $5e611545e491da86$export$bdb8f897727a9c67 = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h900.size, $5e611545e491da86$export$bc02e067df412c3b.h900.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 6.5}px`
    });
const $5e611545e491da86$export$3953fb6fbd158d23 = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h800.size, $5e611545e491da86$export$bc02e067df412c3b.h800.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 5}px`
    });
const $5e611545e491da86$export$e4f993a313607daa = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h700.size, $5e611545e491da86$export$bc02e067df412c3b.h700.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 5}px`
    });
const $5e611545e491da86$export$1e8b2acea3fb3119 = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h600.size, $5e611545e491da86$export$bc02e067df412c3b.h600.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.008em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 3.5}px`
    });
const $5e611545e491da86$export$85aa43a9b9f06707 = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h500.size, $5e611545e491da86$export$bc02e067df412c3b.h500.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.006em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 3}px`
    });
const $5e611545e491da86$export$fcb7764b80bd908f = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h400.size, $5e611545e491da86$export$bc02e067df412c3b.h400.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.003em`,
        marginTop: `${(0, $lcnyw.gridSize)() * 2}px`
    });
const $5e611545e491da86$export$a0e59c3bbc05e815 = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h300.size, $5e611545e491da86$export$bc02e067df412c3b.h300.lineHeight),
        color: `var(--ds-text, ${(0, $PdmhA.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $lcnyw.gridSize)() * 2.5}px`,
        textTransform: 'uppercase'
    });
const $5e611545e491da86$export$7ccf32eb2150ac7e = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h200.size, $5e611545e491da86$export$bc02e067df412c3b.h200.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $lcnyw.gridSize)() * 2}px`
    });
const $5e611545e491da86$export$dfc0e69214efdc3c = (props = {})=>({
        ...$5e611545e491da86$var$baseHeading($5e611545e491da86$export$bc02e067df412c3b.h100.size, $5e611545e491da86$export$bc02e067df412c3b.h100.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: `${(0, $lcnyw.gridSize)() * 2}px`
    });

});


parcelRegister("kMw7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d89ad1f49a8e16$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
const $45d89ad1f49a8e16$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $45d89ad1f49a8e16$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $45d89ad1f49a8e16$var$imageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    maxWidth: `var(${$45d89ad1f49a8e16$var$CSS_VAR_MAX_WIDTH})`,
    maxHeight: `var(${$45d89ad1f49a8e16$var$CSS_VAR_MAX_HEIGHT})`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0 auto ${"var(--ds-space-300, 24px)"}`
});
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $45d89ad1f49a8e16$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $byn9U.jsx)("img", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$45d89ad1f49a8e16$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$45d89ad1f49a8e16$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        css: $45d89ad1f49a8e16$var$imageStyles,
        src: src
    });
var $45d89ad1f49a8e16$export$2e2bcd8739ae039 = $45d89ad1f49a8e16$var$Image;

});

parcelRegister("lueZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f412c0d90a89adc5$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $f412c0d90a89adc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f412c0d90a89adc5$var$spinnerContainerStyles = {
    name: "177e4pm",
    styles: "width:var(--ds-space-300, 24px);margin-left:var(--ds-space-200, 16px)"
};
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $f412c0d90a89adc5$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f412c0d90a89adc5$var$spinnerContainerStyles
    }, children);
var $f412c0d90a89adc5$export$2e2bcd8739ae039 = $f412c0d90a89adc5$var$SpinnerContainer;

});


parcelRegister("1ngde", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a90b15cbc8eca2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $12a90b15cbc8eca2$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $eUqFw.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $12a90b15cbc8eca2$export$2e2bcd8739ae039 = $12a90b15cbc8eca2$var$withAnalyticsContext;

});

parcelRegister("hM7RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $989b57ed5600239a$export$2e2bcd8739ae039);
var $989b57ed5600239a$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("70wqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d7e15ee1eef5bbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8PMUi = parcelRequire("8PMUi");
class $1d7e15ee1eef5bbd$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) return ErrorComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PMUi.default), {
            data: data
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorComponent, null)) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PMUi.default), {
            data: data
        }, children);
    }
}

});

parcelRegister("co43T", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $30065be55d5ee3b4$export$53c2b9c37c40e0d8);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $gNgZO = parcelRequire("gNgZO");
const $30065be55d5ee3b4$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const methodRef = (0, $gNgZO.useTrackedRef)(method);
    const payloadRef = (0, $gNgZO.useTrackedRef)(payload);
    return (0, $eUqFw.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("klDN8", function(module, exports) {

$parcel$export(module.exports, "e100", () => $18c120be06ba3fff$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $18c120be06ba3fff$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e300", () => $18c120be06ba3fff$export$f330dca4c33ed51f);
$parcel$export(module.exports, "e400", () => $18c120be06ba3fff$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "e500", () => $18c120be06ba3fff$export$e6af781b0d301e56);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $3bNek = parcelRequire("3bNek");
const $18c120be06ba3fff$export$b390b459b8b8d8d0 = (0, $3bNek.default)({
    light: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $PdmhA.N50A)}, 0 0 1px 1px ${(0, $PdmhA.N40A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $PdmhA.DN50A)}, 0 0 1px 1px ${(0, $PdmhA.DN40A)}`})`};`
});
const $18c120be06ba3fff$export$3c35fb2adfe0992 = (0, $3bNek.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.DN50A)}, 0 0 1px ${(0, $PdmhA.DN60A)}`})`};`
});
const $18c120be06ba3fff$export$f330dca4c33ed51f = (0, $3bNek.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $PdmhA.DN50A)}, 0 0 1px ${(0, $PdmhA.DN60A)}`})`};`
});
const $18c120be06ba3fff$export$3c7c047ca0ed675e = (0, $3bNek.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $PdmhA.DN50A)}, 0 0 1px ${(0, $PdmhA.DN60A)}`})`};`
});
const $18c120be06ba3fff$export$e6af781b0d301e56 = (0, $3bNek.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $PdmhA.DN50A)}, 0 0 1px ${(0, $PdmhA.DN60A)}`})`};`
});

});


$parcel$global.rlb("hPzOn")
//# sourceMappingURL=shared~vendor~atlaskit~ar.2c4c538d.js.map
